// https://observablehq.com/@berhardki/wie-gelingt-die-energiewende@15819
import define1 from "./4caee69e966109c8@35.js";

async function _1(FileAttachment,start_journey_class_button,$0,$1,$2,$3,plot_heat_map,results_analaysis_scenario,compute_class_coverage,coverage,rounding,coverage_ratio,compute_class_renewable,coverage_renewable,highlight_class,compare_class,demand_class,netto_parameter,flexibility_parameter,demand_class_button,set,$4,$5,$6,$7,demand_result_class,demand_result_class_button,$8,$9,wind_pv_class,wind_onshore_parameter,wind_offshore_parameter,photovoltaik_parameter,wind_pv_class_button,$10,$11,$12,$13,$14,wind_pv_button_text,wind_pv_unrealistic_class,wind_pv_unrealistic_class_button,$15,$16,nuclear_class,nuclear_power_parameter,nuclear_class_button,$17,$18,$19,nuclear_button_text,nuclear_result_class,nuclear_result_class_button,$20,$21,coal_class,brown_coal_power_parameter,hard_coal_power_parameter,coal_class_button,$22,$23,$24,$25,$26,coal_button_text,coal_result_class,coal_result_class_button,$27,$28,$29,backup_class,imports_paramter,gas_power_parameter,electrolysis_parameter,backup_class_button,$30,$31,$32,$33,$34,$35,backup_result_class,backup_result_class_button,netto_parameter_copy,flexibility_parameter_copy,nuclear_power_parameter_copy,brown_coal_power_parameter_copy,hard_coal_power_parameter_copy,wind_onshore_parameter_copy,wind_offshore_parameter_copy,photovoltaik_parameter_copy,imports_paramter_copy,gas_power_parameter_copy,electrolysis_parameter_copy,ratio_renewable_import_parameter_copy,$36,$37,$38,mix_class,htl){return(
htl.html`<link href="${await FileAttachment('bootstrap.min.css').url()}" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">
<h2>Wie gelingt die Energiewende?</h2>
<p>
Die Energiewende in Deutschland ist eine Revolution der Stromversorgung: Sie setzt auf Windräder und Solarzellen, richtet sich damit nach dem Wetter. Das durch Thomas Edison erdachte Prinzip, immer so viel Strom zu erzeugen wie Menschen gerade verbrauchen, wird damit ersetzt durch ein wesentlich älteres: Die Arbeit folgt Wind und Sonne, das Wetter liefert den Takt der Stromerzeugung. Dabei wird es nicht nur gute Stromernten mit großen Überschüssen geben, sondern auch Stromflauten – Zeiten, in denen die Stromerzeuger weniger Strom erzeugen als gebraucht wird.</p>
<p>
Trotzdem soll auch in Zukunft die Stromversorgung zu jedem Zeitpunkt gesichert sein – und zudem bis 2035 auch noch weitgehend klimaneutral. Schon 2030 soll nach den <a href="https://www.bmwi.de/Redaktion/DE/Downloads/Energie/04_EEG_2023.pdf?__blob=publicationFile&v=8" target="_blank">Plänen der Bundesregierung vom April 2022</a> der Anteil der Erneuerbaren am Strommix bei 80 Prozent liegen. Das sieht der Entwurf für das Erneuerbare Energien Gesetz (EEG), das EEG 2023, vor. Windräder und PV-Anlagen müssen dafür in noch nicht dagewesenem Tempo ausgebaut werden. Die klassischen Kraftwerke, die Kohle oder Gas verbrennen, sind Auslaufmodelle. 
</p>
<p>
Allein: Mit dem Ausbau der wetterabhängigen Stromerzeuger muss gleichzeitig eine ausreichend große Flotte an steuerbaren Kraftwerken gebaut werden, die „auf Knopfdruck“ Strom liefern können, um auch bei Windflauten und wenig Sonne den Strombedarf decken zu können. Lesen Sie dazu gerne dieses <a href="https://www.sciencemediacenter.de/fileadmin/user_upload/Fact_Sheets_PDF/Stresstest-fuer-den-vorgezogenen-Kohleausstieg-III_SMC_Fact-Sheet_24112021.pdf" target="_blank">Fact Sheet</a>. Das wirft Fragen auf: Wie lange dauern diese Flauten, wie tief sinkt die erneuerbare Stromerzeugung? Welche Kraftwerke können einspringen, wie viel müssen diese leisten, brauchen sie einen Brennstoff, und wenn ja: welchen? Schließlich soll der Strom künftig rund um die Uhr weitgehend klimaneutral und sicher da sein. 
</p>
<p>
In diesem interaktiven Angebot laden wir Sie ein auf eine guided Tour durch die Stromversorgung in Deutschland. Schritt für Schritt zeigen wir die verschiedenen Komponenten, die für die Energiewende eine entscheidende Rolle spielen. Wir erklären mithilfe der im Text integrierten Schieberegler, wie Sie die Zusammensetzung der Stromversorgung ändern – zum Beispiel den Strombedarf erhöhen oder die Kohlekraftwerke abschalten – und wie Sie zeitgleich die Auswirkungen direkt auf einer kleinen Grafik beobachten können. </p>
<p>
Auf unserer Tour aktiviert jede Änderung ein „Was-wäre-gewesen-wenn-Szenario“: Was hätten diese Anpassungen für die Stromerzeugung zwischen 2015 und 2021 bedeutet? Vergleichbare Verfahren nutzen Forschende, um zu testen, wie robust ihre Stromerzeugungsmodelle sind – wobei <a href="https://www.sciencemediacenter.de/fileadmin/user_upload/Fact_Sheets_PDF/Preppen-fuer-die-Dunkelflaute-I_SMC_Fact-Sheet_24112021.pdf" target="_blank">unser Modell</a> etwas einfacher ist. Die Grafik zeigt auf einen Blick die Ergebnisse des „Was-wäre-gewesen-wenn-Szenarios“: Rechts wirft sie Zahlen für die Versorungssicherheit aus, links zeigt sie alle Tage, an denen der Strombedarf nicht komplett hätte gedeckt werden können und die jeweilige Dauer der Unterdeckung. Wenn alles robust nach Plan läuft, sollte die Grafik leer sein, wie am Anfang: Da zeigt sie, was gewesen wäre, wenn der heutige Kraftwerkspark seit 2015 unverändert bestünde – der Strombedarf wäre immer gedeckt gewesen, aber der Anteil an Erneuerbaren Energien gering. </p>
<p> 

Schritt für Schritt führen wir dann die Werte ein, die wichtig sind für eine ausgeglichene Strombilanz im Jahre 2030. Wir erklären, was sie bedeuten und zeigen, wie Sie diese Werte nach der Tour selbst verändern können. Wir fragen: Wann würden Lücken auftreten, wenn der Strombedarf steigt und einige Kraftwerkstypen vom Netz genommen werden? Wie stark müssten Windkraft- und Photovoltaikanlagen ausgebaut werden, um diese Lücken schließen zu können? Gibt es da Grenzen? Wie viele Back-up-Kraftwerke braucht ein Erneuerbares Energiesystem? </p>
<p> 

Am Ende der Erklärungsreise finden Sie die Komponenten und die entsprechenden Regler auf einem  „Mischpult“ zur Abstimmung einer robusten und klimafreundlichen Strombilanz.  Dann sind Sie an der Reihe: Sie können alle Werte frei einstellen. Optimieren Sie die Stromversorgung Deutschlands ohne Kohle, ohne Atom, mit Wind, PV und Wasserstoff/Biomethan-Back-up-Kraftwerken. </p>
<p>
Wichtig ist nur: Das ist keine Vorhersage! Es ist ein Modell, mit dem man erkennen kann, ob die Energiewende zu einer im großen und ganzen robusten Stromversorgung führt, oder ob noch etwas fehlt. Dafür begrenzen wir den Blick auf die grobe Bilanz, den Ausgleich von Stromerzeugung und Stromverbrauch der Zukunft. Zur gelungenen Energiewende gehört natürlich mehr: Das Stromnetz muss ausgebaut, Heizungen und Verkehr klimafreundlich werden, ein neuer Energiemarkt das ganze zusammenbinden, aber für unsere Frage hier reicht dieser Blick.  </p>
<p> 
Kommen Sie mit auf die Reise!  Wir fangen an mit der Frage: Wie stark wird der Strombedarf in Zukunft steigen? </p>
<p>
  Sie wollen mehr über das Modell wissen? Dann schauen Sie sich die „Annahmen und Methoden“ an. </p>
<p>

<details>
  <summary>Annahmen und Methoden</summary>
<ul>
<li> Als Datengrundlage für die Simulation verwenden wir die von der Bundesnetzagentur auf der Seite <a href="https://www.smard.de/home" target="_blank">SMARD</a> bereitgestellten Erzeugungs- und Verbrauchsdaten.   
<li> Die Erzeuger treten in Anlehnung an das <a href="https://de.wikipedia.org/wiki/Merit-Order" target="_blank"> Merit Order Verfahren </a> in folgender Reihenfolge in Aktion, um den Strombedarf zu decken: Erneuerbare Energien, Kernenergie, Braunkohlekraftwerke, Steinkohlekraftwerke, 60 Prozent der Gaskraftwerke, sonstige Kraftwerke, Stromimporte, restliche 40 Prozent der Gaskraftwerke.
<li> Wenn Braunkohle- und Atomkraftwerke zum Einsatz kommen, gehen wir davon aus, dass diese Kraftwerke aus technischen Gründen nicht auf 0 Gigawatt (GW) Leistung heruntergefahren werden können, auch wenn die Stromerzeugung der Erneuerbaren ausreicht, den Bedarf zu decken. Braunkohlekraftwerke können in unserem Modell bis auf 20 Prozent ihrer Leistung herunterfahren. Das ist die niedrigste Auslastung, die wir in den Daten beobachten konnten. Atomkraftwerke können im Prinzip ähnlich weit heruntergefahren werden, doch in der Praxis ist das unrealistisch. Das Modell passt daher die historischen AKW-Leistungswerte an die eingegebene installierte Leistung an. Das bedeutet, das Modell lässt diese Kraftwerke durchgehend laufen, auch wenn genug Erneuerbarer Strom dagewesen wäre. Im Ergebnis kann der Anteil der Erneuerbaren sinken; in der Realität würde der Strom exportiert, in Wasserstoff umgewandelt – oder schlicht abgeregelt. 
<li> Die sonstigen Kraftwerkstypen (aktuell im Wesentlichen Mineralöl und Gas aus Kohle und Industrieprozessen) werden in Zukunft nur eine sehr geringe Rolle spielen. In der Simulation wird zu Beginn eine Leistung von 7,2 GW angenommen. Um etwaige Fortschritte bei weiteren Technologien Erneuerbarer Energien zu berücksichtigen, wird in der Auswertung die (ohnehin geringe) Erzeugung der sonstigen Kraftwerke zu 50 Prozent den Erneuerbaren Energien zugerechnet. 
<li> Beim importierten Strom gehen wir davon aus, dass aktuell 20 Prozent aus Erneuerbaren Energien stammen. Dies entspricht in etwa dem derzeitigen Anteil der Erneuerbaren Energien am Strommix innerhalb der EU. Für 2030 steigt dieser Anteil auf 32 Prozent. 
<li> Es sind stets genug Rohstoffe, also insbesondere Kohle und Gas, vorhanden, um die Kraftwerke mit der angegebenen maximalen Leistung betreiben zu können. Außerdem gehen wir davon aus, dass bei Bedarf das angegebene Maximum an Strom auch tatsächlich importiert werden kann. 
<li> Wir betrachten nur die Werte der Stromerzeugung und des Verbrauchs innerhalb Deutschlands, also die Strombilanz. Dabei nehmen wir an, dass das Stromnetz auch so ausgebaut ist, dass der erzeugte Strom auch dahin transportiert werden kann, wo er gebraucht wird, ohne Rücksicht auf die regionalen Unterschiede bei der Erzeugung und beim Verbrauch. Das ist natürlich eine Vereinfachung.   
<li> Die voreingestellten Werte entsprechen dem Kraftwerkspark am 1. Januar 2022. 
<li> Mit Stromverbrauch oder Strombedarf ist hier immer der realisierte Stromverbrauch gemeint. Damit ist der Strom gemeint, der tatsächlich bei den Kunden angekommen ist. Von der Gesamt-(Brutto-)Stromerzeugung werden dafür der Eigenbedarf von Kraftwerken, Exportüberschüsse, Netzverluste, Strom für Pumpspeicherkraftwerke und Industrie-Eigenbedarf abgezogen, 2019 ein Wert von gut 100 TWh. Mit Stilllegen der Braunkohle-Tagebaue und dem Fortfall von Exportüberschüssen kann dieser Wert auf rund 40 TWh fallen.  
</ul>  
</details>
<br>

<div class="text-center">
   <button id="start_journey" class=${start_journey_class_button} onclick=${() => {
      $0.value = "btn btn-outline-secondary hidden"
      $1.value = "section_first";
      $2.value = "";
      $3.value = "btn btn-outline-secondary";
     setTimeout(function () {
      window.location.href = "#demand"; 
    }, 10)
      }}>Weiter zum zukünftigen Strombedarf</button>
    </div>

<div class="sticky-top" id="core">
<div class="row">
    <div class="col-12 col-sm-8">
      ${plot_heat_map(results_analaysis_scenario["heatmap"]).rendered}
    </div>
    <div class="col-12 col-sm-4">
    Anteil des abgedeckten Bedarfs:
  <div class="progress" style="height: 20px;">
  <div class=${compute_class_coverage(results_analaysis_scenario["covered_demand"]/results_analaysis_scenario["bedarf_gesamt"])} role="progressbar" style=${coverage} aria-valuenow=${rounding(100*results_analaysis_scenario["covered_demand"]/results_analaysis_scenario["bedarf_gesamt"],3)} aria-valuemin="0" aria-valuemax="100">${rounding(100*results_analaysis_scenario["covered_demand"]/results_analaysis_scenario["bedarf_gesamt"],2).toLocaleString("de")}%</div>
</div>

       Anteil komplett abgedeckter Stunden:
  <div class="progress" style="height: 20px;">
  <div class=${compute_class_coverage(1-results_analaysis_scenario["coverage"])} role="progressbar" style=${coverage_ratio} aria-valuenow=${rounding(100-100*results_analaysis_scenario["coverage"],1)} aria-valuemin="0" aria-valuemax="100">${rounding(100 - 100*results_analaysis_scenario["coverage"],1).toLocaleString("de")}%</div>
</div>
      Anteil Erneuerbarer Energien am Bedarf:
        <div class="progress" style="height: 20px;">
  <div class=${compute_class_renewable((results_analaysis_scenario["covered_demand"] - results_analaysis_scenario["fossil"])/results_analaysis_scenario["bedarf_gesamt"])} role="progressbar" style=${coverage_renewable} aria-valuenow=${rounding(100*(results_analaysis_scenario["covered_demand"] - results_analaysis_scenario["fossil"])/results_analaysis_scenario["bedarf_gesamt"],1)} aria-valuemin="0" aria-valuemax="100">${rounding(100*(results_analaysis_scenario["covered_demand"] - results_analaysis_scenario["fossil"])/results_analaysis_scenario["bedarf_gesamt"],1).toLocaleString("de")}%</div>
</div>
      <br>
      Die größte Versorgungslücke beträgt: <span class = ${highlight_class}> <b>${Math.abs(rounding(results_analaysis_scenario["max_gap"]/1000,2)).toLocaleString("de")} GW</b></span>
    </div>
  <details class=${compare_class}>
  <summary ><b>Vergleich mit Werten aus der Tour</b></summary>
<img src="${await FileAttachment("grafik_ende_geschichte@6.jpg").url()}" style="height: 200px"/>
    </details>
</div>
</div>

<div id="demand" class=${demand_class}>
  <h5>Der Strombedarf der Zukunft - höher aber flexibler</h5>
    <p>
      Wir fangen mit dem Verbrauch der Zukunft an, denn danach muss sich ja die ganze Stromversorgung richten. Sie haben wahrscheinlich schon gehört, dass fast alle Experten und die Politik davon ausgehen, dass der Verbrauch deutlich steigen wird. Heute liegt er bei rund <span class="demand_color">510 TWh</span>, für 2030 nimmt das Bundeswirtschaftsministerium einen Brutto-Strombedarf von  <span class="demand_color">750 TWh</span> an. Bis 2045 könnte der Strombedarf verschiedenen Studien zufolge auf <span class="demand_color">900 bis 1200 TWh</span> klettern. Das liegt nicht an neuen Rechnern oder mehr Konsum, sondern daran, dass mit grünem Strom der Klimawandel gebremst wird. Strom ersetzt das Feuer, könnte man sagen, in Heizungen, Fabriken und in Autos. Und je mehr dieser „Feuerstellen“ wir durch Strom ersetzen, desto stärker sinkt der Gesamt-Energieverbrauch. Darum geht es bei der Energiewende.  <br><br>
      Mit dem ersten Regler können Sie einstellen, wie hoch der Stromverbrauch in Zukunft sein wird. Nach rechts geht der Verbrauch hoch, nach links runter.  (Dafür sinkt dann aber auch der Primärenergiebedarf durch eingespartes Öl, Gas und Kohle kräftig!) Falls Sie einen Wert zur Hand haben, an dem das Label „Bruttostrom“ hängt, ziehen Sie für 2030 getrost etwa 40 TWh ab, für 2045er-Werte können wir noch keinen Tipp geben. (Mehr dazu unter „Annahmen und Methoden“.) </p>
<div class="demand_color">${netto_parameter}</div>
<br>
  <p>
Wind und Sonne kümmern sich aber nicht um die Verbraucher. Das bedeutet, es wird immer Situationen geben, in denen zu wenig Strom da ist. Diese Lücke – Fachleute nennen sie Residuallast – kann man drücken, wenn der Stromverbrauch etwas gesenkt wird. Das nennen Fachleute dann „flexibilisieren“. Zum Beispiel mit Batterien: Die können Strom speichern, wenn zu viel da ist und wieder abgeben, wenn zu wenig erzeugt wird. Alleine durch die wachsende Flotte an Elektrofahrzeugen entsteht theoretisch ein gigantischer Stromspeicher, der Strom auch wieder ins Netz schicken kann. Oder der langsamer geladen wird, falls die Stromerzeugung sinkt.  Auch Wärmepumpen können ihren Verbrauch anpassen und Stromüberschüsse für Mangelzeiten speichern: als Warmwasser. Gibt es für kurze Zeit weniger Strom als Bedarf, heizen diese mit Wasser aus dem Wärmespeicher. So wird der Strombedarf im Haushalt ein wenig an die Erzeugung von Strom aus Windkraft und Sonnenenergie angepasst. Vergleichbares gilt auch für die Industrie.<br><br> 
    Mit dem zweiten Regler können Sie für kurze Zeit den aktuellen Strombedarf etwas drücken. Was Sie hier einstellen, entspricht dabei dem Wert, der maximal pro Stunde von der Bedarfskurve abgezogen werden kann. Der Gesamtbedarf wird dabei nicht gesenkt, aber gestreckt: Wenn an einer Stelle der Bedarf reduziert wird, muss er an einer anderen Stelle – später – wieder erhöht werden. In der Simulation wird der Bedarf pro Tag so – im Rahmen der Möglichkeiten – an die Stromerzeugung angepasst. Daumenregel: Fünf Prozent des Bedarfs gelten als einfach umzusetzen, zehn Prozent als sportlich! Der Bedarf pro Stunde kann 2030 zwischen 60 und 120 GWh schwanken. 
<!--Diesen Wert müssen wir noch im Energy-Explorer testen-->  
  </p>       
<div class="flexibility_color">${flexibility_parameter}</div>
<br>
  <p>
<b>Unsere Einstellung für das Jahr 2030:</b>
Wenn Sie gleich auf „Strombedarf an Werte für 2030 anpassen“ klicken, wird der erste Regler automatisch auf <span class="demand_color">710 TWh</span> gesetzt – der Wert ergibt sich aus dem Entwurf für das EEG 2023 minus 40 TWh für Netzverluste und Industriestrom, der gar nicht über das Stromnetz läuft. Der zweite Regler stellt sich auf <span class="flexibility_color"> 10 GW</span>: Das scheint nach unseren Recherchen ein realistischer Wert für 2030 zu sein. Die Flexibilität des Strombedarfs ist im Jahr 2030 voraussichtlich noch begrenzt; andererseits rechnen Experten mit 10 bis 14 Millionen  Elektroautos, ein sehr großes Potenzial. Klicken Sie jetzt und schauen Sie, ob der noch gar nicht angepasste Kraftwerkspark den erhöhten Strombedarf schon auffangen könnte. Beobachten Sie die Auswirkung in der obigen Grafik und bei den Zielgrößen Stromabdeckung und Anteil Erneuerbarer Energien. 
</p>
        
        <div class="text-center"><!--Button Strombedarf an Werte für 2030 anpassen--> 
    <button id="increase_demand" class=${demand_class_button} onclick=${() => {
      set(netto_parameter, 710);
      set(flexibility_parameter, 10);
      $4.value = "section_result bold";
      setTimeout(function () {
      $3.value = "btn btn-outline-secondary";
      $5.value = "btn btn-outline-secondary";
      $3.value = "btn btn-outline-secondary hidden";
      $4.value = "bold";
      $6.value = 710;
      $7.value = 10;
      window.location.href = "#demand_result"; }, 10);
      }}>Strombedarf an Werte für 2030 anpassen</button>
        </div>
<br>
</div>
  <p id="demand_result" class=${demand_result_class}><!--Text Erste Auswertung 2030 --> 
    <b>Das Ergebnis:</b><br>
  Das ist gut gegangen – die Grafik ist leer. Aber: Das war eine ganz schön knappe Sache... Erneuerbare sind ja noch nicht ausgebaut, wenn da nur wenige GW an Kraftwerken abgeschaltet werden, entstehen schon Löcher... trotzdem heißt das: Wenn der Verbrauch 2030 tatsächlich so weit klettert, wir 10 GW davon aber flexibel bedienen können und die Erneuerbaren so viel Strom liefern wie in den Jahren 2015 bis 2021, dann kann der Kraftwerkspark von 2022 diesen Verbrauch stemmen. Allerdings fiele der Anteil an Erneuerbaren Energien auf weit unter 40 Prozent. Das ist logisch, weil wir ja die Leistung im Modell noch nicht erhöht haben. Das ist das wichtigste Ziel der Energiewende, das sehen wir uns daher als nächstes an.   

    <div class="text-center"><!--Weiter zu Erneuerbare Energien Button-->
    <a href=#wind_pv><button id="increase_demand_result" class=${demand_result_class_button} onclick=${() => {
      $8.value = "section_result_wind_pv";
      $9.value = "btn btn-outline-secondary";
      $5.value = "btn btn-outline-secondary hidden";
      $4.value = "";
      setTimeout(function () {
      window.location.href = "#wind_pv"; 
      }, 10)
      }}>Weiter zum Ausbau der Erneuerbaren Energien</button></a>
      </div>
 <br><br>
<div id="wind_pv" class=${wind_pv_class}><!--Erneuerbaren Energien Text "wind_pv"-->
<h5>Der Ausbau von Windkraft- und Photovoltaikanlagen</h5>
  <p>
    Windräder und PV-Anlagen sollen 2030 das Rückgrat der Stromversorgung sein. Wasserturbinen, Biomasse-Anlagen oder Geothermie-Kraftwerke erzeugen zwar auch fast ohne Kohlendioxid Strom, aber ihr Beitrag für die Energiewende ist begrenzt: Wasserkraft gilt als ausgereizt, Biomasse konkurriert um Anbauflächen zum Beispiel für Essen und bei Geothermie ist seit 20 Jahren kein großer Fortschritt erkennbar. Einige Fachleute vermuten sogar einen Rückgang der Leistung von Biomasse-Kraftwerken. In unserem Modell lassen wir daher die Erzeugungswerte für Wasser- und Biomasse-Kraftwerke so, wie sie 2022 sind. Dafür gibt es keine Regler. <br>
Die Werte für Windkraft- und PV-Anlagen können Sie aber über Regler einstellen, und dann werden die Werte der installierten Leistung aus dem Datensatz für die Stromerzeugung zwischen 2015 und 2021 angehoben und die Erzeugung in der Datenbasis anschließend umgerechnet. Das Modell tut so, als hätte es in diesem Zeitraum bereits so viele Anlagen gegeben, und Sie können sehen, ob die Stromversorgung sicher gewesen wäre. War sie das, wäre sie es wohl auch bei vergleichbaren Bedingungen in der Zukunft. 
    <br><br>
<b>Windkraft an Land</b>. Derzeit sind in Deutschland Windräder mit einer Gesamtleistung von <span class="wind_onshore_color">55,6 GW</span> installiert. Wenn Sie jetzt schon mal die Regler für die Leistung bedienen, können Sie sich anzeigen lassen, wir viel Leistung jedes Jahr fertig gebaut und ans Netz gehen müsste, um das Ziel bis 2030 oder 2045 zu erreichen. </p>
  <div class="wind_onshore_color">${wind_onshore_parameter}</div>
    <br>
  <p>
     <b>Dieser Wert bedeutet:</b> Soll dieses Ausbauziel bis 2030 erreicht werden, müssten ab 2023 jedes Jahr     
    <span class="wind_onshore_color">${rounding((wind_onshore_parameter.value - 55.6)/7,1).toLocaleString("de")} GW </span> ans Netz gehen, bis 2045 jedes Jahr
          <span class="wind_onshore_color"> ${rounding((wind_onshore_parameter.value - 55.6)/22,1).toLocaleString("de")} GW</span>. Zum Vergleich: Von 2010 bis zur Einführung der Ausschreibungen 2017 wurden im Schnitt 3,3 GW pro Jahr ans Netz angeschlossen. Nach 2017 sank die Zahl bis 2020 auf einen
          Schnitt von 1,4 GW.  
           <br>
<br> 
<b>Windkraft im Meer</b>. Derzeit sind in Deutschland Offshore-Windparks mit einer Gesamtleistung von rund <span class="wind_offshore_color">7,8 GW</span> installiert. Auch diesen Wert können Sie anheben und beobachten, wie viel Leistung jedes Jahr fertig gebaut und ans Netz gehen müsste. </p>
 <div class="wind_offshore_color">${wind_offshore_parameter}</div>
  <p>
     <b>Dieser Wert bedeutet:</b> Soll dieses Ausbauziel bis 2030 erreicht werden, müssten ab 2023 jedes Jahr     
       
    <span class="wind_offshore_color">${rounding((wind_offshore_parameter.value - 7.8)/7,1).toLocaleString("de")} GW</span> ans Netz gehen, bis 2045 jedes Jahr
          <span class="wind_offshore_color">${rounding((wind_offshore_parameter.value - 7.8)/22,1).toLocaleString("de")} GW</span>. Zum Vergleich: Bis 2020 betrug der maximale Ausbau im Jahr gut 2 GW, zwischen 2011 und 2020 betrug er im Schnitt jedoch nur gut ein GW pro Jahr. Nach Einführung von Ausschreibungen
            sackte der Zubau ab, 2021 wurde kein Offshore-Windpark angeschlossen. 
<br>
    <br>
<b>Photovoltaikanlagen</b>. Derzeit sind in Deutschland Photovoltaik-Anlagen unterschiedlicher Größe mit einer Gesamtleistung von rund <span class="pv_color">56,3 GW</span> installiert. Auch hier können Sie sich anzeigen lassen, wie viel Leistung jedes Jahr installiert werden müsste, um das Ziel zu erreichen. </p>
 <div class="pv_color">${photovoltaik_parameter}</div>
  <p>
<b>Dieser Wert bedeutet:</b> Soll dieses Ausbauziel bis 2030 erreicht werden, müssten ab 2023 jedes Jahr
    
        <span class="pv_color"> ${rounding((photovoltaik_parameter.value - 56.3)/7,1).toLocaleString("de")} GW</span> ans Netz gehen, bis 2045 jedes Jahr
          <span class="pv_color"> ${rounding((photovoltaik_parameter.value - 56.3)/22,1).toLocaleString("de")} GW</span>. Zum Vergleich: Zwischen 2015 und 2020 lag der durchnittliche jährliche Ausbau bei rund 3 GW.<br>
    <br>
    <b>Unsere Einstellung für das Jahr 2030:</b>
   Nach dem Entwurf für das  EEG 2023 sollen 2030 folgende Leistungen installiert sein: <span class="wind_onshore_color">115 GW</span> Onshore Windkraftanlagen, <span class="wind_offshore_color">30 GW</span> Offshore Windanlagen und <span class="pv_color">215 GW PV-Anlagen</span>. Die Frage ist: Reichen diese Leistungen aus? Klicken Sie auf „Windkraft- und PV-Anlagen nach EEG ausbauen“, beobachten Sie, was sich ändert. Die Grafik müsste leer bleiben, da ja viel mehr Leistung hinzukommt; spannend ist: Wie hoch wird der Anteil der Erneuerbaren? 
      </p>
      <div class="text-center"><!--Hier habe ich die Zahlen angepasst. Hoffentlich war das richtig?-->
    <button id="build_wind_pv_parks" class=${wind_pv_class_button} onclick=${() => {
      set(wind_onshore_parameter, 115);
      set(wind_offshore_parameter, 30);
      set(photovoltaik_parameter, 215);
      $10.value = "section_result bold";
      setTimeout(function () {
      window.location.href = "#wind_pv_result"; 
      $11.value = "btn btn-outline-secondary";
      $9.value = "btn btn-outline-secondary hidden";
      $12.value = 115;
      $13.value = 30;
      $14.value = 215;}, 10);
      }}>${wind_pv_button_text}</button>
      </div>
</div>
<br>    <!--Ich bin bis hier hin gekommen 12.04.09:15-->
  <p id="wind_pv_result" class=${wind_pv_unrealistic_class}><!--Auswertung Erneuerbare Energien Text-->
       <b>Die Auswirkung:</b><br>
  Wie erwartet blieb die Grafik leer. Dafür ist der Anteil der Erneuerbaren auf 71 Prozent geklettert. Das heißt: Wenn die Erneuerbaren kräftig ausgebaut werden, der Netzbedarf 2030 tatsächlich bis auf 710 TWh  klettert, 10 GW davon aber flexibel bedient werden können und die Erneuerbaren so viel Strom liefern wie in den Jahren 2015 bis 2021, dann gibt es jeden Tag genug Strom und das Ziel von 80 Prozent ist fast erreicht. Das ist ein Erfolg! Aber: In dieser Rechnung sind auch noch die Kohle- und Atomkraftwerke drin, und Deutschland will ja aus aus beiden aussteigen. An dem Ziel rüttelt die Bundesregierung nicht, trotz Ukrainekrieg und drohendem Gas-Embargo. Gehen wir Schritt für Schritt vor, sehen wir uns als nächstes an, was passiert, wenn die AKW in den Ruhestand gehen. 

  </p>
   <div class="text-center"><!--Button Weiter zu den Atomkraftwerken-->
 <button id="" class=${wind_pv_unrealistic_class_button} onclick=${() => {
      $15.value = "section_chapter";
      $16.value = "btn btn-outline-secondary";
      $11.value = "btn btn-outline-secondary hidden";
      $4.value = "";
      setTimeout(function () {
      window.location.href = "#nuclear"; 
      }, 10)
      }}>Weiter zu den Atomkraftwerken</button>
  </div>

<br><br><!--Block "nuclear", Ausstieg aus der Kernenergie-->
<div id="nuclear" class=${nuclear_class}>
    <h5>Der Austieg aus der Kernenergie</h5>
    <p> Frankreich will neue Atomkraftwerke bauen, Großbritannien ebenfalls, und Polen gar in die Atomverstomung ganz neu einsteigen. Kein Wunder, dass der Eindruck entsteht, Atomenergie erlebe eine Renaissance. Deutschland allerdings hält am Ausstieg aus der Atomenergie fest. Ende 2022 werden die letzten drei Meiler abgeschaltet. Die Frage ist: Entstehen dann doch Versorgungslücken? Das schauen wir jetzt an, dafür ist der nächste Regler da. Mit dem können Sie die Leistung der Atomkraftwerke einstellen. 2022 sind noch 4,1 GW am Netz. Der Regler ist nach oben auf 12 GW begrenzt, mehr Leistung war seit Jahren nicht mehr am Stromnetz. Es ist unwahrscheinlich, dass bis 2030 oder 2045 diese Leistung in Deutschland überhaupt erreicht werden kann. </p><!--Eine weitere Frage ist: Könnten AKW den Back-UP Bedarf reduzieren. Das müssten wir später aufgreifen. -->
    <div class="nuclear_color">${nuclear_power_parameter}</div>
  <p>
      <b>Unsere Einstellung für das Jahr 2030:</b>
    Da der Atomausstieg beschlossen bleibt, wird für unsere Tour der Regler auf <span class="nuclear_color">0 GW</span> gestellt, sowie Sie auf die Schaltfläche „Atomkraftwerke vom Netz nehmen“ klicken. Denken Sie daran: Behalten Sie die Grafik und den Anteil der Erneuerbaren an der Stromversorgung im Blick, beide können sich ändern! Nehmen Sie jetzt die AKW vom Netz.  <br>
      </p>
  <div class="text-center"><!--Button Atomausstieg berechnen-->
   <button id="exit_nuclear" class=${nuclear_class_button} onclick=${() => {
     $17.value = "section_result bold";
     set(nuclear_power_parameter,0);
     setTimeout(function () {
      $16.value = "btn btn-outline-secondary hidden";
      $18.value = "btn btn-outline-secondary";
      window.location.href = "#nuclear_result"; 
      $19.value = 0; }, 10);
      }}>${nuclear_button_text}</button>
  </div>
</div>
<br>
  <p id="nuclear_result" class=${nuclear_result_class}>
    <b>Die Auswirkung:</b><br>
    Gut gegangen – die Grafik ist leer. Interessant: Der Anteil der Erneuerbaren am Stromverbrauch stieg sogar, um mehr als ein Prozent. Da wir die installierte Leistung der Erneuerbaren nicht angetastet haben, bedeutet das: Die Stromerzeugung muss auch schon vorher da gewesen sein, konnte aber nicht genutzt werden (Vergleiche hierzu auch die Annahmen zu AKW in „Annahmen und Methoden“). Für unsere Tour heißt das: Wenn die Atomkraftwerke abgeschaltet und die Erneuerbaren kräftig ausgebaut werden, der Netzbedarf 2030 tatsächlich bis auf 710 TWh  klettert, 10 GW davon aber flexibel bedient werden können, und die Erneuerbaren so viel Strom liefern wie in den Jahren 2015 bis 2021, dann gibt es jeden Tag genug Strom und die Erneuerbaren erhöhen ihren Anteil noch. Die Frage ist jetzt: Lassen sich auch die Kohlekraftwerke abschalten und der Anteil der Erneuerbaren steigern?     
</p>

<!--Button Weiter zum Kohleausstieg-->
<div class="text-center">
   <button id="exit_nuclear" class=${nuclear_result_class_button} onclick=${() => {
      $20.value = "section_chapter";
      $17.value = "";
     $18.value = "btn btn-outline-secondary hidden";
      $21.value = "btn btn-outline-secondary";
     setTimeout(function () {
      window.location.href = "#coal"; 
      }, 10)
      }}>Weiter zur Kohleverstromung</button>
      </div>
<br><br><!--Text Kohleausstieg-->
 <div id="coal" class=${coal_class}>
    <h5>Der Austieg aus der Kohleverstromung</h5>
  <p> 
    Eigentlich soll das letzte Kohlekraftwerk – ein Braunkohlekraftwerk – erst 2038 vom Netz gehen. Aber die Bundesregierung möchte möglichst schon 2030 aus der Kohlekraft austeigen. Kein Wunder, denn Braunkohlekraftwerke sind die schlimmsten Kohlendioxid-Verursacher der Stromerzeugung. Steinkohlekraftwerke verursachen viel geringere Treibhausgasemissionen, manche Experten sehen sie sogar fast auf einer Höhe mit Erdgaskraftwerken. (Da muss man aber sehr ins Detail schauen, das ist nicht die Frage hier.) <br><br>
    Mit den nächsten beiden Reglern können Sie die Leistung der Kohlekraftwerke getrennt nach Braun- und Steinkohle reduzieren. Nach dem gültigen Kohleausstieg sollen 2030 keine Steinkohlekraftwerke mehr laufen, aber noch 9,6 GW Braunkohleleistung installiert sein. </p>
   <div class="brown_coal_color">${brown_coal_power_parameter}</div>
   <div class="hard_coal_color">${hard_coal_power_parameter}</div>
   <p>
    <b>Unsere Einstellung für das Jahr 2030:</b>
 Weil die Bundesregierung plant, idealerweise möglichst alle Kohlekraftwerke vom Netz gehen zu lassen, wollen wir auf dieser Tour ausprobieren, ob das Ideal ohne weitere Änderungen erreichbar ist. Daher werden der Regler für Braunkohlekraftwerke auf <span class="brown_coal_color"> 0 GW </span> und der für Steinkohlekraftwerke auch auf <span class="hard_coal_color">0 GW</span> gestellt, sowie Sie auf die Schaltfläche klicken. Wie immer, denken Sie daran: Behalten Sie die Grafik und den Anteil der Erneuerbaren an der Stromversorgung im Blick! (Gleichzeitig gehen übrigens auch eine Reihe von sogenannten „sonstigen“ Kraftwerken vom Netz, Kraftwerke, die zum Beispiel Öl, Abfall oder Grubengas verfeuern und 2030 auch keinen Strom mehr liefern. Da diese in der Diskussion keine Rolle spielen, haben wir dafür keinen eigenen Regler vorgesehen.) Nehmen Sie jetzt die Kohlekraftwerke vom Netz.  </p>
      <div class="text-center"><!--Button Kohleausstieg berechnen-->
    <button id="exit_coal" class=${coal_class_button} onclick=${() => {
      set(brown_coal_power_parameter,0);
      set(hard_coal_power_parameter,0);
      $22.value = "section_result bold";
      setTimeout(function () {
      window.location.href = "#coal_result"; 
      $23.value = "btn btn-outline-secondary";
      $21.value = "btn btn-outline-secondary hidden";
      $24.value = 0;
      $25.value = 4.2;
      $26.value = 0;}, 10);
      }}>${coal_button_text}</button>
      </div>
    </div>
<br>
  <p id="coal_result" class= ${coal_result_class}><!--Text Kohleausstieg Ergebnis-->
       <b>Die Auswirkung:</b><br>
  Das Ergebnis ist gemischt. Auf der einen Seite stieg der Anteil der Erneuerbaren um knapp drei Prozent. Das ist so nahe an den 80 Prozent, für eine Modellrechnung wie unsere kann man daher sagen, eins der Ausbauziele ist so gut wie erreicht. <br><br>
    Das große „Aber“ zeigt sich auf der Grafik, die bis jetzt immer leer war: Hier wimmelt es von Flecken, hellgeben, dunkelgelben, roten. Gut zehn Prozent der berechneten Zeit hätte es nicht genügend Strom gegeben, maxmial haben gut 38 GW Leistung gefehlt – in etwa soviel wie die Leistung der stillgelegten Kohlekraftwerke. Allerdings wäre der Bedarf insgesamt dennoch zu fast 99 Prozent gedeckt. <br><br>
    Das heißt: Wenn alle Kohlekraftwerke (und ein kleiner Teil der Sonstigen) stillgelegt, die Atomkraftwerke abgeschaltet und die Erneuerbaren kräftig ausgebaut werden, der Netzbedarf 2030 tatsächlich bis auf 710 TWh  klettert, 10 GW davon aber flexibel bedient werden können, und die Erneuerbaren so viel Strom liefern wie in den Jahren 2015 bis 2021, dann ist das Ausbauziel so gut wie erreicht, aber es gibt an vielen Tagen zu wenig Strom. <br><br>
    Was tun? Das haben wir uns gefragt, als wir die Tour vorbereitet haben. Reicht es, einige Kohlekraftwerke am Netz zu lassen? Kaum, da ja fast so viel Leistung fehlt, wie wir abgeschaltet haben. Die Atomkraftwerke sind da auch keine Hilfe. Probieren Sie es am Ende der Tour gern einmal selbst aus. Nein, die Lösung finden Sie unter dem Knopf „Weiter zu den Back-up-Möglichkeiten“.   
      </p>

<div class="text-center">
    <button id="" class=${coal_result_class_button} onclick=${() => {
      $22.value = "";
      $27.value = "section_chapter";
      $28.value = "btn btn-outline-secondary hidden";
      $29.value = "btn btn-outline-secondary";
      setTimeout(function () {
      window.location.href = "#backup"; 
      }, 10)
      }}>Weiter zu den Back-up-Möglichkeiten</button>
 </div>

<div id="backup" class=${backup_class}>
<h5>Strom auf Knopfdruck – Back-up für dunkle und windstille Tage</h5>
      <p>
          Wenn die alten Grundlastkraftwerke nicht ausreichen, um die Lücken in der Stromversorgung sicher zu stopfen, dann muss eine andere Technik her. Die gibt es auch schon, sogar zwei. <br>
        Die eine hört auf die Bezeichnung „Grenzkuppelstellen“. Das sind schlicht und einfach Stromleitungen, die in die Nachbarländer führen. Über diese kann Strom importiert werden, wenn hier welcher fehlt.  Aktuell kann aus technischen Gründen eine Leistung von maximal <span class="imports_color">15 GW </span>importiert werden, bis 2030 soll die Leitung auf 36 GW steigen. Das ist viel! Aber es reicht nicht, die Leistungssteigerung ist zu gering. Außerdem: Wenn es in Deutschland dunkel, kalt und windstill ist, leiden wahrscheinlich auch die Nachbarländer darunter. Es kann durchaus sein, dass aus dem Ausland kaum Strom nach Deutschland importiert werden kann, weil der Strom vor Ort gebraucht wird. </p>
  <div class="imports_color">${imports_paramter}</div>
<br>
  <p>
        Die andere Technik nennen Wissenschaftler „Residuallastkraftwerke“ – Kraftwerke, die lange still stehen, aber bei Bedarf blitzschnell hochgefahren werden können und sinkende Einspeisung durch Wind- und PV-Anlagen abfangen. Damit alle Strom erhalten. Das sind alle Kraftwerke, die Erdgas nutzen: Turbinen, Motoren oder Brennstoffzellen. Alle davon sind auch „putinsicher“, weil sie sich mit Bio-Methan betreiben lassen oder – angepasst – auch mit Wasserstoff. Bis 2030 könnte genug Biomethan und Wasserstoff erzeugt werden, dass es für die Kraftwerke reicht – und für etwas mehr. So umgerüstet, wären diese Back-up-Generatoren gleichzeitig auch klimaneutral. <br> Aktuell sind rund <span class="gas_color">31 GW</span> Leistung installiert. Experimentieren Sie am Ende der Tour mit diesem Regler, wie hoch die installierte Leistung sein muss, um für eine 100-prozentige Deckung des Bedarfs zu sorgen. Je weniger Flecken die Grafik zeigt, desto näher dran sind Sie. Bedenken Sie auch: Mehr Residuallastkraftwerke im Inland können mehr Sicherheit bedeuten, falls Erneuerbare in großen Teilen Europas wenig Strom erzeugen. Aber je mehr Kraftwerke Sie bauen, desto seltener werden diese laufen, und desto teuerer wird der erzeugte Strom...    </p>

  <div class="gas_color">${gas_power_parameter}</div>
<br>
  <p>
Wenn wir schon mal bei Wasserstoff sind – warum auf halben Wege sehen bleiben? Wasserstoff kann mit Strom erzeugt werden. Erneuerbare wie Wind und Photovoltaik liefern gelegentlich nicht nur weniger Strom als gebraucht, sondern oft auch mehr. Dann müssen die Anlagen eigentlich abgeregelt werden. Aber: Wenn Sie zusätzliche Elektrolyseure installieren, können Sie diesen Überschuss nutzen, Wasserstoff erzeugen, sammeln und als Treibstoff für die Gaskraftwerke nutzen. Die Bundesregierung plant derzeit 10 GW Elektrolyseurleistung für 2030, die mehr oder weniger rund um die Uhr betrieben werden. Zusätzlich dazu würden Ihre Anlagen Wasserstoff erzeugen, eine guter Test, wie viel von den Überschüssen sich für schlechte Zeiten aufheben lässt. So kann man den Anteil der Erneuerbaren auch vergrößern. </p>
        
  <div class="elektrolysis_color">${electrolysis_parameter}</div>
        <br>

  <!--12.04.12:56: ich bin jetzt bis hierhin gekommen. Die Importe würde ich rausnehmen
  
  <p>
Der importierte Strom sollte natürlich möglichst auch aus Erneuerbaren Energien stammen, um die Klimaziele zu erreichen. Bei Dunkelflauten könnte beispielsweise Strom aus Wasserkraftanlagen in den Alpen oder Skandinavien zur Verfügung stehen. Auch ist es möglich, dass in anderen Teilen Europas doch kräftig Wind weht. Vorausgesetzt, es gibt das Stromnetz dafür, könnte sogar Wind von der Spanischen oder Marokkanischen Atlantikküste oder aus Sibirien importiert werden. Ansonsten verfügen die Niederlande noch über eine große Flotte von Gaskraftwerken, Polen über Kohlestrom und Frankreich über seine Atom-Armada. Den Anteil an Erneuerbaren Energien am Importstrom können Sie hier variieren, aber wie bei der Importleistung gilt: Vorsicht! Ist in Deutschland der Erneuerbare Strom knapp, ist er es wahrscheinlich auch bei unseren Nachbarn.</p> 
       
        <br>        
  
  -->


<p>
<b>Unsere Einstellung für das Jahr 2030:</b>
Derzeit verfügt Deutschland über Gaskraftwerke mit einer Leistung von 31,3 GW. In den kommenden Jahren kommen 3,5 GW hinzu, Pläne für weitere 4,4 GW sind <a href="https://www.bmwi.de/Redaktion/DE/Parlamentarische-Anfragen/2022/03/20-633.pdf?__blob=publicationFile&v=4" target="_blank">bekannt</a>. Wenn wir mögliche Abschaltungen aus Altersgründen außer Acht lassen, ergibt das für 2030 eine mögliche installierte Leistung von <span class="gas_color">39,2 GW</span>. Weiter nehmen wir für unser Modell an, dass die von der Bundesregierung geplanten 10 GW Elektrolyseure mit Überschußstrom betrieben werden, um zu zeigen, wie viel Wasserstoff damit gewonnen werden könnte.<br>
Für die Importe folgen wir dem  Verband der Europäischen Stromnetzbetreiber. Der rechnet für 2030 mit einer maximalen Importleistung von <span class="imports_color">36 GW</span> nach Deutschland. Wir nehmen an, dass diese Leistung voll für den Import genutzt werden kann und dass im Schnitt <span class="imports_renewable_color">32 Prozent</span> des importierten Stroms aus Erneuerbaren Energien stammt. Dies entspricht dem für das Jahr 2030 angestrebten Anteil der Erneuerbaren Energien am Strommix innerhalb der EU, laut <a href="https://eur-lex.europa.eu/legal-content/DE/TXT/PDF/?uri=CELEX:32018L2001&from=DE" target="_blank"> aktueller EU-Richtline</a>. 
      </p> 

          <div class="text-center">
   <button id="build_back_up" class=${backup_class_button} onclick=${() => {
     set(imports_paramter, 36);
     set(gas_power_parameter, 39.2);
     set(electrolysis_parameter, 10);
     $30.value = "section_result bold";
     setTimeout(function () {
     window.location.href = "#backup_result"; 
     $31.value = "btn btn-outline-secondary";
     $29.value = "btn btn-outline-secondary hidden";
     $32.value = 36;
     $33.value = 39.2;
     $34.value = 10;
     $35.value = 0.32;}, 10);
      }}>Ausbau der Gaskraftwerke, der Importleistung und der Elektrolyseure</button>
 </div>
<br>
  <p id="backup_result" class=${backup_result_class}>
       <b>Die Auswirkung:</b><br>
      Das sieht deutlich besser aus: Die Zahl der Flecken ist deutlich geschrumpft. Der Anteil der Erneuerbaren steigt noch mal ein bisschen, er liegt bei über 77 Prozent. Das könnte am Rückverstomen von Wasserstoff liegen. Aber es fehlen knapp 9 GW Leistung, um alle verbliebenen Flecken verschwinden zu lassen. Das heißt: Wenn alle Kohlekraftwerke und ein kleiner Teil der Sonstigen stillgelegt, die Atomkraftwerke abgeschaltet und die Erneuerbaren kräftig ausgebaut werden, der Netzbedarf 2030 tatsächlich bis auf 710 TWh  klettert, 10 GW davon aber flexibel bedient werden können, die Erneuerbaren so viel Strom liefern wie in den Jahren 2015 bis 2021, für knapp 40 GW Gaskraftwerke, und für rund 36 GW Importkapazitäten als Back-up für windstille oder dunkle Stunden zur Verfügung stehen, dann gibt es schon wieder fast genug Strom für alle. Wenn jetzt die Gaskraftwerkleistung auf 47,9 GW erhöht wird, sind alle Löcher wieder verschwunden. Ob es diese Gaskraftwerke 2030 geben wird, ob sie Bio-Methan, Wasserstoff oder noch Erdgas verfeuern werden, ist jetzt eine politische Entscheidung.  <br><br>
 <b>Unsere Tour ist hier zu Ende. </b><br>
    Sie haben gesehen: Ein Stromsystem mit rund 80 Prozent Energie aus Erneuerbaren ist machbar. Legen wir die realisierte Stromerzeugung für 2015 bis 2021 zu Grunde, würde es zu rund 99 Prozent der Zeit genügend Strom liefern. Für das letzte Prozent braucht es genügend Back-up, denn in diesen Stunden sind die Löcher offenbar groß. Rund 48 GW Gaskraftwerke und 36 GW Importe brauchten wir bei unserem Rundgang, um die Strombilanz im Modell wieder in Ordnung zu bringen. Das ist ungefähr die Größenordung, die von verschiedenen Forschergruppen in der Vergangenheit auch abgeschätzt wurde. Dieser Aspekt spricht nicht gegen die Energiewende – schließlich können ja auch Wasserstoff oder Biomethan für die Back-up-Kraftwerke eingesetzt werden, das ist dann immer noch nachhaltig. Aber es sollte in der politischen Diskussion nicht vergessen werden!  <br><br> 
    Jetzt sind Sie an der Reihe. Schaffen Sie es auch, die Stromversorung auf rund 80 Prozent Erneuerbare zu bringen und robust zu halten? Wie viele Lücken lassen sich noch durch einen Mehrausbau an Wind und PV schließen? Ist das realistisch? In der Vergangenheit waren drei bis fünf Gigawatt möglich, heute leisten die Anlagen etwas mehr, etwas mehr könnte möglich sein. Wägen Sie ab, ob Sie sich auf die 36 GW Importkapazität verlassen wollen – ist in Deutschland Flaute, ist oft in den Nachbarländern auch Flaute, aber nicht immer! Wollen Sie auf Nummer sicher gehen, bauen Sie vielleicht doch mehr Gaskraftwerke? Und mehr Elektrolyseure? Recherchieren Sie auch, was Bio-Methan für eine Rolle spielen könnte. Vor diesen Entscheidungen stehen jetzt alle in der Stromversorgung, Politiker und Unternehmen. <br><br>

<!-- Kompliziert? Es geht noch mehr: Auch Mitte des Jahrhunderts, wenn Deutschland durch Umstellung von Verkehr, Industrie und Gebäuden klimaneutral ist, werden wahrscheinlich flexibel steuerbare Kraftwerke in genügender Anzahl notwendig sein. Windkraft- und PV-Anlagen müssten dann noch stärker ausgebaut sein. Dann lohnen sich aber die Elektrolyseure auch mehr: Stehen genügend bereit, kann aus den Stromüberschüssen vor allem im Sommer viel Wasserstoff für die Flauten im Winter gewonnen werden. Genügend? Was Sie nicht erzeugen, müssen Sie importieren. Auch ein größerer Anteil des Stromverbrauchs sollte flexibel werden, sich viel stärker als heute an die Erzeugung von Strom aus Windkraft und Sonnenenergie anpassen. Versuchen Sie einmal, weiter in die Zukunft zu blicken und entwerfen Sie ein möglichst klimaneutrales und robustes Stromsystem, um einen Bedarf von 1000 bis 1500 TWh zu decken, wie er für Mitte des Jahrhunderts prognostiziert wird.  <br>-->

<b>Am Ende...</b><br> 
    ...sei nochmal erinnert: Das ist keine Prognose! Es ist ein Szenario mit realen Stromerzeugungsdaten. Das heißt, so ungefähr könnte es kommen, wenn sich die Bedingungen wiederholen. Das ist viel: So ein Szenario hilft ganz ungemein, ein Problem zu erkennen und abzuschätzen, wie groß es ist. Das Problem ist: Irgendwie muss Strom für die Stunden beschafft werden, in denen ein bisschen oder viel Erneuerbarer Strom fehlt, und das Szenario zeigt: Es wird wahrscheinlich passieren, aber die Technik, um sich darauf vorzubereiten, ist da und kann auch schon gebaut werden. Gemeinsam mit den Nachbarn in Europa (denen wir logischerweise auch Strom liefern, wenn er bei denen knapp ist) und mit Back-up Kraftwerken im eigenen Land. <br>
    Vieles haben wir vereinfacht, auch das gehört dazu: Wo die Windräder stehen, fließt nicht in die Simulation ein, auch nicht, wie gut das Stromnetz ausgebaut ist oder wie es betrieben wird. Das zum Beispiel kann einzelne Werte beeinflussen. Auch die Kosten, zum Beispiel für den Bau der Gaskraftwerke und den Strom, den sie liefern sollen, haben wir nicht mitmodelliert, das wäre schlicht zu viel.  <br><br>

Wenn Sie fertig sind und Ihre Ergebnisse sehen, kommen vielleicht neue Fragen auf. Fragen wie: Back-up-Kraftwerke werden seltener laufen als heute, wie sollen diese finanziert werden? Europa will sich von Russischem Erdgas unabhängig machen, kann der Stromsektor da vorangehen? Mit Biogas oder Wasserstoff? Was kostet ein Elektrolyseur, und gibt es denn schon welche, die immer mal wieder ein paar Tage Pause machen können? Wie bekommen Sie die Menschen dazu, Windräder in ihrer Nachbarschaft zu dulden, oder sogar zu begrüßen, sich vielleicht sogar darum zu reißen? Wie schafft man es, den Stromverbrauch zu flexibilisieren? Wie überzeugt man die Menschen, Wärmepumpen in Häuser oder vielleicht besser Quartiere zu installieren? Wie schaffen Sie es, den womöglich knappen Wasserstoff für die Stromversorgung zu reservieren? Und braucht man wirklich so viel Energie, oder kann man durch mehr Effizienz und Verzicht den Bedarf senken? Bedenken Sie dabei auch, dass wir möglichst alles, was Gas, Kohle oder Öl verfeuert, durch Strom ersetzen wollen: Wir senken den Kohlendioxid-Ausstoß und verbrauchen nur einen Bruchteil der Energie.   <br><br>

Sie werden sehen: Die Energiewende ist möglich – aber dafür muss sich viel bewegen! <br><br>

Packen wir es an! <br>

  </p>
  <div class="text-center">
   <button id="build_back_up_result" class=${backup_result_class_button} onclick=${() => {
     $31.value = "btn btn-outline-secondary hidden";
     set(netto_parameter_copy, 710);
     set(flexibility_parameter_copy, 10);
     set(nuclear_power_parameter_copy,0);
     set(brown_coal_power_parameter_copy,0);
     set(hard_coal_power_parameter_copy,0);
     set(wind_onshore_parameter_copy, 115);
     set(wind_offshore_parameter_copy, 30);
     set(photovoltaik_parameter_copy, 215);
     set(imports_paramter_copy, 36);
     set(gas_power_parameter_copy, 39.2);
     set(electrolysis_parameter_copy, 10);
     set(ratio_renewable_import_parameter_copy, 32);
     $6.value= 710;
     $7.value = 10;
     $19.value = 0;
     $24.value = 0;
     $26.value = 0;
     $12.value = 115;
     $13.value = 30;
     $14.value = 215;
     $32.value = 36;
     $33.value = 39.2;
     $34.value = 10;
     $35.value = 0.32
     $30.value = ""; 
     $36.value = "section_last";
     $37.value = "height:380px; width:100%";
     $38.value = "blinking";
     setTimeout(function () {
      $38.value = ""; 
      }, 3000)
      setTimeout(function () {
      window.location.href = "#mix"; 
      }, 10)
      }}>Die Stromversorgung sicherstellen und den Anteil an Erneuerbaren Energien erhöhen</button>
             </div>
  <br><br>
<div id="mix" class=${mix_class}>
<h5>Das zukünftige Stromsystem</h5>
               <p>
Hier betreten Sie nun die Spielwiese. Alle Parameter aus der Erzählung mit den entsprechenden Werten sind hier noch einmal zusammengefasst und können verändert werden, um ein robustes und klimafreundliches Stromsystem zu generieren. 
               </p>
  <b>Strombedarf und Lastenmanagement</b>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="demand_color">${netto_parameter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="flexibility_color">${flexibility_parameter_copy}</div>
    </div>
  </div>
  
  <b>Windraft- und PV-Anlagen</b>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="wind_onshore_color">${wind_onshore_parameter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="wind_offshore_color">${wind_offshore_parameter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="pv_color">${photovoltaik_parameter_copy}</div>
    </div>
  </div>
<p>
  Notwendiger jährlicher Ausbau bis 2030 (2045): Wind Onshore: <span class="wind_onshore_color">${rounding((wind_onshore_parameter_copy.value - 55.6)/7,1).toLocaleString("de")} GW (${rounding((wind_onshore_parameter_copy.value - 55.6)/22,1).toLocaleString("de")} GW)</span>, Wind Offshore: <span class="wind_offshore_color">${rounding((wind_offshore_parameter_copy.value - 7.8)/7,1).toLocaleString("de")} GW (${rounding((wind_offshore_parameter_copy.value - 7.8)/22,1).toLocaleString("de")} GW) </span>, Photovoltakik: <span class="pv_color">${rounding((photovoltaik_parameter_copy.value - 56.3)/7,1).toLocaleString("de")} GW (${rounding((photovoltaik_parameter_copy.value - 56.3)/22,1).toLocaleString("de")} GW)</span>
</p>
        
 
  <b>Back-up</b>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="imports_color">${imports_paramter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="gas_color">${gas_power_parameter_copy}</div>
    </div>
  </div>

  <b>Erneuerbare im Back-up</b>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4">
       <div class="imports_renewable_color">${ratio_renewable_import_parameter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="elektrolysis_color">${electrolysis_parameter_copy}</div>
    </div>

  </div>
  
  <b>Auslaufende Kraftwerkstypen</b>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="brown_coal_color">${brown_coal_power_parameter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="hard_coal_color">${hard_coal_power_parameter_copy}</div>
    </div>
    <div class="col-12 col-md-6 col-lg">
     <div class="nuclear_color">${nuclear_power_parameter_copy}</div>
    </div>
  </div>
  </div>
`
)}

function _2(extra_space,htl){return(
htl.html`<div style=${extra_space}>&nbsp;</div>`
)}

function _3(htl){return(
htl.html`<h2 class="hidden">Appenddix</h2>`
)}

function _4(htl){return(
htl.html`<h2 class="hidden">Style</h2>`
)}

async function _5(html,FileAttachment,width){return(
html`<style>
.progress-bar {
  text-align: left;
  transition-duration: 3s;
}

@font-face {
  font-family: "Aller";
  src: local("Aller"), url(${await FileAttachment("Aller_Rg.ttf").url()}) format("truetype");
}

* {
  font-family: "Aller" !important;
}
#body {
  background-image: url(${await FileAttachment("bg.jpg").url()});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.notebook {
  background: #fff;
}
.my-title {
  text-align: center;
  color: #81700f;
  font-size: 46px;
  font-weight: bold;
}



.button {
	cursor: pointer;
	border: 1px solid #8A7705;
  height: 30px;
	background: none;
	box-shadow: none;
	border-radius: 5px; /*angles' curvature*/
	margin: 4px; /*free space around the button*/
  color: #8A7705;
  display: inline-block; /*buttons horizontally aligned*/
  text-align: center;
  padding-left: 5px; /*distance between button border and text*/
  padding-right: 5px;
}

.button:hover {
  background: #f8f3d3;
}

.annotated {
  position: relative;
  display: inline-block;
  background-color: #faf2c5;
  padding-left: 3px;
  padding-right: 3px;
}

.annotated:hover {
  background: #faf2c5;
}

.annotation {
  visibility: hidden;
  background-color: #f8f3d3;
  padding-left: 3px;
  padding-right: 3px;
  position: absolute;
  z-index: 1;
  line-height: 0.1;
  margin-left: 50px;
  min-width: ${width/2.0}px;
  visibility: hidden;
  border: solid 0.5px #666;
  box-shadow: 0 0 5px #ccc;
  padding: 5px;
  position: absolute;
  z-index: 1;
  line-height: 1;
bottom: 60%;
}

.annotated:hover .annotation {
  opacity: 1;
  visibility: visible;
}

/* RANGE BASE STYLE */
input[type=range] {
  -webkit-appearance: none;
  width: 200px;
  height: 3px;
  background: #c6c6c6;
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

input[type=range]:focus {
  outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
}

input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;

  /* Hides the slider so custom styles can be added */
  background: transparent; 
  border-color: transparent;
  color: transparent;
}

/* RANGE SLIDER THUMB */
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  //border: 1px solid #000000;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #d7c455;
  cursor: pointer;
  /*margin-top: -14px;*/ /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
}

/* All the same stuff for Firefox */
input[type=range]::-moz-range-thumb {
  // border: 1px solid #000000;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #d7c455;
  cursor: pointer;
}

/* All the same stuff for IE */
input[type=range]::-ms-thumb {
  //border: 1px solid #000000;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #d7c455;
  cursor: pointer;
}

input[type=number], input[type=text] {
  padding: 5px 7px;

  background: #fff;
  border: 1px solid #c6c6c6;
  border-radius: 3px;
} 
input[type=number]:focus-visible, input[type=text]:focus-visible {
  border: 1px solid #d7c455;
  // box-shadow: 0;
  outline: none;
}


/* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: pink;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-top: none;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  //z-index: auto;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
div#core {
  background-color: #fafafa;
}

.blinking{
    animation:blinkingText 1s infinite;
}
@keyframes blinkingText{
     50% {
    opacity: 0;
  }
}
bold{
  padding: 1em;
  border: 2px solid #d7c455;
  border-radius: 4px;
}

</style>`
)}

function _compare_class(){return(
"hidden"
)}

function _highlight_class(){return(
""
)}

function _extra_space(){return(
"height:1000px; width:100%"
)}

function _coverage(rounding,results_analaysis_scenario){return(
"width: "+String(rounding(100*results_analaysis_scenario["covered_demand"]/results_analaysis_scenario["bedarf_gesamt"],3))+"%;"
)}

function _coverage_ratio(rounding,results_analaysis_scenario){return(
"width: "+String(rounding(100 - 100*results_analaysis_scenario["coverage"],3))+"%;"
)}

function _coverage_renewable(rounding,results_analaysis_scenario){return(
"width: "+ String(rounding(100*(results_analaysis_scenario["covered_demand"] - results_analaysis_scenario["fossil"])/results_analaysis_scenario["bedarf_gesamt"],1))+"%;"
)}

function _start_text_class(){return(
"hidden"
)}

function _nuclear_class(){return(
"hidden"
)}

function _nuclear_result_class(){return(
"hidden"
)}

function _start_journey_class_button(){return(
"btn btn-outline-secondary"
)}

function _nuclear_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _nuclear_result_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _coal_class(){return(
"hidden"
)}

function _coal_result_class(){return(
"hidden"
)}

function _coal_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _coal_result_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _wind_pv_class(){return(
"hidden"
)}

function _wind_pv_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _demand_class(){return(
"hidden"
)}

function _demand_result_class(){return(
"hidden"
)}

function _demand_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _demand_result_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _start_text_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _backup_class(){return(
"hidden"
)}

function _backup_result_class(){return(
"hidden"
)}

function _backup_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _backup_result_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _wind_pv_unrealistic_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _wind_pv_unrealistic_result_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _mix_class(){return(
"hidden"
)}

function _wind_pv_unrealistic_class(){return(
"hidden"
)}

function _wind_pv_unrealistic_result_class(){return(
"hidden"
)}

function _wind_pv_unrealistic_result_after_class_button(){return(
"btn btn-outline-secondary hidden"
)}

function _nuclear_button_text(){return(
"Atomkraftwerke vom Netz nehmen"
)}

function _coal_button_text(){return(
"Kohlekraftwerke vom Netz nehmen"
)}

function _wind_pv_button_text(){return(
"Windkraft- und PV-Anlagen nach EEG ausbauen"
)}

function _42(htl){return(
htl.html`<h2 class="hidden">Parameter viewof - Initialisierungen</h2>`
)}

function _43(htl){return(
htl.html`<p class="hidden"> netto_parameter</p>`
)}

function _netto_parameter($0,Inputs,netto_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([netto_parameter_scenario, 1700], {value: netto_parameter_scenario, step: 1, label:"Stombedarf (TWh)"}), {
  oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                      $1.value = event.currentTarget.value;}
}))
)}

function _netto_parameter_copy($0,Inputs,netto_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([netto_parameter_scenario, 1700], {value: netto_parameter_scenario, step: 1, label:"Stombedarf (TWh)"}), {
  oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _46(htl){return(
htl.html`<p class="hidden"> flexibility_parameter</p>`
)}

function _flexibility_parameter($0,Inputs,flexibility_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: flexibility_parameter_scenario, label:"Flexible Leistung (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _flexibility_parameter_copy($0,Inputs,flexibility_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: flexibility_parameter_scenario, label:"Flexible Leistung (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _49(htl){return(
htl.html`<p class="hidden">wind_onshore_parameter</p>`
)}

function _wind_onshore_parameter($0,Inputs,wind_onshore_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([wind_onshore_parameter_scenario, 300], {step: 0.1, value: wind_onshore_parameter_scenario, label: "Wind Onshore (GW)"}) , {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _wind_onshore_parameter_copy($0,Inputs,wind_onshore_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([wind_onshore_parameter_scenario, 300], {step: 0.1, value: wind_onshore_parameter_scenario, label: "Wind Onshore (GW)"}) , {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _52(htl){return(
htl.html`<p class="hidden">wind_offshore_parameter</p>`
)}

function _wind_offshore_parameter($0,Inputs,wind_offshore_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([wind_offshore_parameter_scenario, 80], {step: .1, value: wind_offshore_parameter_scenario, label: "Wind Offshore (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _wind_offshore_parameter_copy($0,Inputs,wind_offshore_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([wind_offshore_parameter_scenario, 80], {step: .1, value: wind_offshore_parameter_scenario, label: "Wind Offshore (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _55(htl){return(
htl.html`<p class="hidden">photovoltaik_parameter</p>`
)}

function _photovoltaik_parameter($0,Inputs,photovoltaik_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([photovoltaik_parameter_scenario, 500], {step: .1, value: photovoltaik_parameter_scenario, label: "Photovoltaik (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _photovoltaik_parameter_copy($0,Inputs,photovoltaik_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([photovoltaik_parameter_scenario, 500], {step: .1, value: photovoltaik_parameter_scenario, label: "Photovoltaik (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _58(htl){return(
htl.html`<p class="hidden">ratio_renewable_import_parameter</p>`
)}

function _ratio_renewable_import_parameter_copy($0,Inputs,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 100], {step: 1, value: 20, label: "Anteil EE am Import (%)"}), {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value/100;}
}))
)}

function _60(htl){return(
htl.html`<p class="hidden">electrolysis_parameter</p>`
)}

function _electrolysis_parameter($0,Inputs,electrolysis_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 90], {step: 1, value: electrolysis_parameter_scenario, label: "Elektrolyseure (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _electrolysis_parameter_copy($0,Inputs,electrolysis_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 90], {step: 1, value: electrolysis_parameter_scenario, label: "Elektrolyseure (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _63(htl){return(
htl.html`<p class="hidden">imports_paramter</p>`
)}

function _imports_paramter($0,Inputs,imports_paramter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: imports_paramter_scenario, label:"Importe (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _imports_paramter_copy($0,Inputs,imports_paramter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: imports_paramter_scenario, label:"Importe (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _66(htl){return(
htl.html`<p class="hidden">gas_power_parameter</p>`
)}

function _gas_power_parameter($0,Inputs,gas_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 180], {step: .1, value: gas_power_parameter_scenario, label:"Gasbasierte KW (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _gas_power_parameter_copy($0,Inputs,gas_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 180], {step: .1, value: gas_power_parameter_scenario, label:"Gasbasierte KW (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _69(htl){return(
htl.html`<p class="hidden">brown_coal_power_parameter</p>`
)}

function _brown_coal_power_parameter($0,Inputs,brown_coal_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: brown_coal_power_parameter_scenario, label:"Braunkohle (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _brown_coal_power_parameter_copy($0,Inputs,brown_coal_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: brown_coal_power_parameter_scenario, label:"Braunkohle (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _72(htl){return(
htl.html`<p class="hidden">hard_coal_power_parameter</p>`
)}

function _hard_coal_power_parameter($0,Inputs,hard_coal_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: hard_coal_power_parameter_scenario, label:"Steinkohle (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _hard_coal_power_parameter_copy($0,Inputs,hard_coal_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 50], {step: .1, value: hard_coal_power_parameter_scenario, label:"Steinkohle (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _75(htl){return(
htl.html`<p class="hidden">nuclear_power_parameter</p>`
)}

function _nuclear_power_parameter($0,Inputs,nuclear_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 12], {step: .1, value: nuclear_power_parameter_scenario, label: "Atomkraftwerke (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event =>  {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _nuclear_power_parameter_copy($0,Inputs,nuclear_power_parameter_scenario,Event,$1){return(
$0.bind(Object.assign(Inputs.range([0, 12], {step: .1, value: nuclear_power_parameter_scenario, label: "Atomkraftwerke (GW)"}),  {oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event =>  {event.currentTarget.dispatchEvent(new Event("input"));
                     $1.value = event.currentTarget.value;}
}))
)}

function _78(htl){return(
htl.html`<h2 class="hidden">Daten</h2>`
)}

function _data_for_scenario(FileAttachment){return(
FileAttachment("data_for_scenario_analysis@1.csv").csv()
)}

function _80(htl){return(
htl.html`<h2 class="hidden">Parameter Szenarien</h2>`
)}

function _netto_parameter_scenario(){return(
500
)}

function _netto_parameter_scenario_view(View,netto_parameter_scenario){return(
new View(netto_parameter_scenario)
)}

function _wind_onshore_parameter_scenario(){return(
55.6
)}

function _wind_onshore_parameter_scenario_view(View,wind_onshore_parameter_scenario){return(
new View(wind_onshore_parameter_scenario)
)}

function _technology_wind_parameter_scenario(){return(
"Entwicklung 2030"
)}

function _wind_offshore_parameter_scenario(){return(
7.8
)}

function _wind_offshore_parameter_scenario_view(View,wind_offshore_parameter_scenario){return(
new View(wind_offshore_parameter_scenario)
)}

function _photovoltaik_parameter_scenario(){return(
56.3
)}

function _photovoltaik_parameter_scenario_view(View,photovoltaik_parameter_scenario){return(
new View(photovoltaik_parameter_scenario)
)}

function _storage_pump_capacity_parameter_scenario(){return(
50
)}

function _storage_pump_power_parameter_scenario(){return(
9.2
)}

function _storage_battery_capacity_parameter_scenario(){return(
5
)}

function _electrolysis_parameter_scenario(){return(
1
)}

function _electrolysis_parameter_scenario_view(View,electrolysis_parameter_scenario){return(
new View(electrolysis_parameter_scenario)
)}

function _imports_paramter_scenario(){return(
15
)}

function _imports_paramter_scenario_view(View,imports_paramter_scenario){return(
new View(imports_paramter_scenario)
)}

function _gas_power_parameter_scenario(){return(
30.5
)}

function _gas_power_parameter_scenario_view(View,gas_power_parameter_scenario){return(
new View(gas_power_parameter_scenario)
)}

function _brown_coal_power_parameter_scenario(){return(
19.1
)}

function _brown_coal_power_parameter_scenario_view(View,brown_coal_power_parameter_scenario){return(
new View(brown_coal_power_parameter_scenario )
)}

function _hard_coal_power_parameter_scenario(){return(
18.8
)}

function _hard_coal_power_parameter_scenario_view(View,hard_coal_power_parameter_scenario){return(
new View(hard_coal_power_parameter_scenario)
)}

function _nuclear_power_parameter_scenario(){return(
4.1
)}

function _nuclear_power_parameter_view(View,nuclear_power_parameter_scenario){return(
new View(nuclear_power_parameter_scenario )
)}

function _flexibility_parameter_scenario(){return(
0
)}

function _flexibility_parameter_scenario_view(View,flexibility_parameter_scenario){return(
new View(flexibility_parameter_scenario)
)}

function _scenario(){return(
"aktuell"
)}

function _technology_factor(select_technology_value){return(
select_technology_value("Entwicklung 2030")
)}

function _storage_management_scenario(){return(
"Residuallastminimierung"
)}

function _flexibility_given(){return(
"nicht explizit angegeben"
)}

function _ratio_renewable_import_parameter_view(View){return(
new View(22)
)}

function _112(htl){return(
htl.html`<h2 class="hidden">Werte, die an Funktionen übergeben werden</h2>`
)}

function _netto_parameter_function(){return(
500
)}

function _wind_onshore_parameter_function(){return(
55.6
)}

function _wind_offshore_parameter_function(){return(
7.8
)}

function _photovoltaik_parameter_function(){return(
56.3
)}

function _storage_pump_capacity_parameter_function(){return(
50
)}

function _storage_pump_power_parameter_function(){return(
9.2
)}

function _storage_battery_capacity_parameter_function(){return(
2.5
)}

function _storage_battery_power_parameter_function(){return(
5
)}

function _electrolysis_parameter_function(){return(
1
)}

function _imports_paramter_function(){return(
15
)}

function _gas_power_parameter_function(){return(
30.5
)}

function _brown_coal_power_parameter_function(){return(
19.1
)}

function _hard_coal_power_parameter_function(){return(
18.8
)}

function _nuclear_power_parameter_function(){return(
4.1
)}

function _other_power_plants_parameter_function(){return(
7.2
)}

function _flexibility_parameter_function(){return(
0
)}

function _years_scenario_parameter_function(){return(
["2015", "2016", "2017", "2018", "2019", "2020", "2021"]
)}

function _technology_factor_function(select_technology_value){return(
select_technology_value("Entwicklung 2030")
)}

function _storage_management_function(){return(
"Residuallastminimierung"
)}

function _ratio_renewable_import_parameter_function(){return(
0.2
)}

function _133(htl){return(
htl.html`<h2 class="hidden">Analyseergebnisse</h2>`
)}

function _134(htl){return(
htl.html`<h3 class="hidden">Szenario</h3>`
)}

function _data_scenario(generate_scenario_data,data_for_scenario,photovoltaik_parameter_function,wind_offshore_parameter_function,wind_onshore_parameter_function,technology_factor_function,nuclear_power_parameter_function,brown_coal_power_parameter_function,hard_coal_power_parameter_function,gas_power_parameter_function,imports_paramter_function,other_power_plants_parameter_function,electrolysis_parameter_function,storage_pump_capacity_parameter_function,storage_pump_power_parameter_function,storage_battery_capacity_parameter_function,storage_battery_power_parameter_function,storage_management_function,netto_parameter_function,flexibility_parameter_function,years_scenario_parameter_function){return(
generate_scenario_data(data_for_scenario, photovoltaik_parameter_function, wind_offshore_parameter_function, 
   wind_onshore_parameter_function, technology_factor_function, nuclear_power_parameter_function, brown_coal_power_parameter_function, hard_coal_power_parameter_function, gas_power_parameter_function, imports_paramter_function, 0.6, other_power_plants_parameter_function, electrolysis_parameter_function, storage_pump_capacity_parameter_function, storage_pump_power_parameter_function, storage_battery_capacity_parameter_function, storage_battery_power_parameter_function,  storage_management_function, netto_parameter_function, flexibility_parameter_function, years_scenario_parameter_function)
)}

function _results_analaysis_scenario(generate_analysis_scenario,data_scenario){return(
generate_analysis_scenario(data_scenario)
)}

function _137(htl){return(
htl.html`<h2 class="hidden">Variablen für Auswertungstexte</h2>`
)}

function _138(htl){return(
htl.html`<h2 class="hidden">Konstanten</h2>`
)}

function _efficiency_electricity_gas(){return(
0.73
)}

function _efficiency_gas_electricity(){return(
0.42
)}

function _dates_of_a_year_365(getDates){return(
getDates("2015-01-01", "2015-12-31", "DD.MM")
)}

function _dates_of_a_year_366(getDates){return(
getDates("2016-01-01", "2016-12-31", "DD.MM")
)}

function _dates_2015(getDates){return(
getDates("2015-01-01", "2015-12-31", "YYYY/MM/DD")
)}

function _dates_2016(getDates){return(
getDates("2016-01-01", "2016-12-31", "YYYY/MM/DD")
)}

function _dates_2017(getDates){return(
getDates("2017-01-01", "2017-12-31", "YYYY/MM/DD")
)}

function _dates_2018(getDates){return(
getDates("2018-01-01", "2018-12-31", "YYYY/MM/DD")
)}

function _dates_2019(getDates){return(
getDates("2019-01-01", "2019-12-31", "YYYY/MM/DD")
)}

function _dates_2020(getDates){return(
getDates("2020-01-01", "2020-12-31", "YYYY/MM/DD")
)}

function _dates_2021(getDates){return(
getDates("2021-01-01", "2021-12-31", "YYYY/MM/DD")
)}

function _150(htl){return(
htl.html`<h1 class="hidden">Funktionen</h1>`
)}

function _151(htl){return(
htl.html`<h3 class="hidden">Anwendungsbezogene Funktionen</h3>`
)}

function _compute_dsm(_){return(
function(data, flexibility, residual_col, demand_col) {
  /**
  Optimization of demand w.r.t to the residual of wind and solar: Goal: Minimize maximum residual for each day. 
  Args:
      data (Array[Dict]): Data including the power demand and the residual "demand minus power generated by wind and solar parks". Each entry of the 
                          array contains data of one specific hour.
      flexibility (Number): Demand that can be shifted within 24 hours
      residual_col (String): key of the data containing the residual (power-wind-solar) 
      demand_col (String): key of the data containing the power demand
   Returns:
       data, where each entry of the array contains the following additional keys: 
      "Bedarf nach DSM" (Number): optimized demand  
      "Residuallast Abweichung" (Number): gap that remains after shifting to obtain a perfect balanced residual
      "Anteil Verschiebung" (Number): ratio (amount substracted or added)/(initial demand) 
      "Verschiebung" (Number): amount substracted or added
  */
  let index = 0; 
  let demand_shifts = []; 
  let residuals_gap_from_avg = [];
  /**Optimize each day separately. Method: Adjust the demand such that the residual is eqaual for each hour. In general this is not possible as the shifts are limited. Thus, the method trys to balance the residual as much as possible w.r.t to the given maximal flexibility. 
  */
  while (index < data.length) {
    let batch = data.slice(index, index+24); // get data of one day 
    let residuals = _.pluck(batch, residual_col).map(Number);
    let demand = _.pluck(batch, demand_col).map(Number);
    let residuals_avg = residuals.reduce((pv, cv) => pv + cv, 0)/24.0;
    let residuals_avg_diff = residuals.map(element => element - residuals_avg); // gap from average of residual for each hour 
    // cut the shifts w.r.t. the maximum possible shift
    let max_possible_shift = residuals_avg_diff.map(element => {if(element<0) {return Math.max(element, -1.0*flexibility)} else {return Math.min(element, flexibility)}});
    // In order to maintain the initial demand, we need to compute an array that sums to zero
    let max_possible_shift_avg = max_possible_shift.reduce((pv, cv) => pv + cv, 0)/24.0;
    let max_possible_shift_avg_diff = max_possible_shift.map(element => element - max_possible_shift_avg);
    let max_shift = Math.max(...max_possible_shift_avg_diff.map(element => Math.abs(element)));
    // Note that during the previous computation the maximum shift might again exceed the maximum flexibility. If so, we scale the shifts to adress this issue. 
    if (max_shift > flexibility) {
      let ratio = max_shift/flexibility;
      max_possible_shift_avg_diff = max_possible_shift_avg_diff.map(element => element/ratio)
    }
    // final demand that is substracted or added for each hour of the day 
    demand_shifts = demand_shifts.concat(max_possible_shift_avg_diff);
    residuals_gap_from_avg = residuals_gap_from_avg.concat(residuals_avg_diff);
    index += 24;
  }
    // shift amount and store the gap that still exist for a perfect balance of the residual 
    data.forEach((element,index) => {
      element["Residuallast Abweichung"] = residuals_gap_from_avg[index]- demand_shifts[index];
      element["Bedarf nach DSM"] = Number(element[demand_col]) - demand_shifts[index];
      element["Anteil Verschiebung"] = Math.abs(demand_shifts[index])/Number(element[demand_col]);
      element["Verschiebung"] = Math.abs(demand_shifts[index]);
  
    });
 /**As we optimize each day separately (which makes sense as the demand cannot be shifted to some point in the far future). However, if the average residual significantly differs betwenn two consecutive days there might occure unnatural jumps of the demand at midnight. Thus, we need to balance the demand around midnight*/
  if (flexibility > 0) {
    let index_midnight = 0;
    while (index_midnight < data.length-24) {
    let gap = data[index_midnight+23]["Bedarf nach DSM"] - data[index_midnight+24]["Bedarf nach DSM"]; // gap between 23:00 and 0:00 
    // balance the demand
    data[index_midnight+22]["Bedarf nach DSM"] = data[index_midnight+22]["Bedarf nach DSM"] - gap/4.0;
    data[index_midnight+23]["Bedarf nach DSM"] = data[index_midnight+23]["Bedarf nach DSM"] - gap/2.5;
    data[index_midnight+24]["Bedarf nach DSM"] = data[index_midnight+24]["Bedarf nach DSM"] + gap/2.5;
    data[index_midnight+25]["Bedarf nach DSM"] = data[index_midnight+25]["Bedarf nach DSM"] + gap/4.0;
    // adjust the gap betweeen the demand and a perfect balanced residual 
    data[index_midnight+22]["Residuallast Abweichung"] = data[index_midnight+22]["Residuallast Abweichung"] - gap/4.0;
    data[index_midnight+23]["Residuallast Abweichung"] = data[index_midnight+23]["Residuallast Abweichung"] - gap/2.5;
    data[index_midnight+24]["Residuallast Abweichung"] = data[index_midnight+24]["Residuallast Abweichung"] + gap/2.5;
    data[index_midnight+25]["Residuallast Abweichung"] = data[index_midnight+25]["Residuallast Abweichung"] + gap/4.0;

    index_midnight += 24;
  }
  }
  return data;
    
}
)}

function _generate_scenario_data(compute_increase_ratio,compute_dsm){return(
function(
    data,
    photovoltaik_installed, 
    wind_offshore_installed, 
    wind_onshore_installed,
    solar_wind_technology_factor,
    nuclear_power_installed,
    brown_coal_installed,
    hard_coal_installed,
    gas_power_installed,
    import_europe,
    utilized_capacity_gas_before_other_and_import,
    other_power_plants_installed,
    electrolysis_power_installed,
    pump_storage_capacity,
    pump_storage_power,
    battery_storage_capacity, 
    battery_storage_power,
    storage_management_parameter,
    demand_per_year,
    flexibility,
    years) {
    /**
    Compute the energy mix for each hour. 
    Args:
        data (Array[Dict]): Data of historic electric energy demand and supply. Each entry contains data for one specific hour 
        photovoltaik_installed (Number): Installed power of PV plants (Gigawatt)
        wind_offshore_installed (Number): Installed power of Offshore plants (Gigawatt)
        wind_onshore_installed (Number): Installed power of Onshore plants (Gigawatt)
        solar_wind_technology_factor Array[Number]: increase of efficency for [pv, onshore, offshore] plants
        nuclear_power_installed (Number): Installed power of nuclear plants (Gigawatt)
        brown_coal_installed (Number): Installed power of brown coal plants (Gigawatt)
        hard_coal_installed (Number): Installed power of hard coal plants (Gigawatt)
        gas_power_installed (Number): Installed power of gas power plants (Gigawatt)
        import_europe (Number): Maximum Capacity of electric power that can be imported (Gigawatt)
        utilized_capacity_gas_before_other_and_import (Number): Capacity of gas power plants utilized before other plants and import are triggered 
        other_power_plants_installed (Number): Installed power of other power plants such as oil etc. (Gigawatt)
        electrolysis_power_installed (Number): Installed power of electrolysis plants (Gigawatt)
        pump_storage_capacity (Number): Capacity of pumped storage power plants (GWh) 
        pump_storage_power (Number): Power of the installed pumped storage power plant (GW)
        battery_storage_capacity (Number): Capacity of the battery storage (GWh)
        battery_storage_power (Number): Power of the battery storage (Gigawatt)
        storage_management_parameter (String): Indicates if the storage is filled only when supply exceeds demand or to minimize the residual (demand-wind-solar)
        demand_per_year (Number): Electric power demand per year (TWh)
        flexibility (Number): Demand that can be shifted during one day to reduce the residual (Gigawatt)
        years (Arry[String]): Considered years

    Returns:
        data, where each entry of the array contains the following additional keys: 
        "Residual vor DSM" (Number): Residual before demand side management
        "Photovoltaik Szenario" (Number): Power from PV plants
        "Wind Offshore Szenario"(Number): Power from offshore plants
        "Wind Onshore Szenario" (Number): Power from onshore plants
        "PV und Wind" (Number): Total power from wind and PV plants
        "Bedarf"(Number): Demand before demnand side managment (historic demand * increase of power)
        "Speicherenergie Pumpspeicher" (Number): Power from pump storage
        "Speicherenergie Batterien" (Number): Power form batteries
        "Bedarf und Laden" (Number): Demand plus power to charge storage
        "Leistung Elektrolyseure" (Number): Power of elektrolysis
        "Ungenutzter Überschuss" (Number): Unused power
        "Braunkohle Szenario" (Number): Power from brown coal plants
        "Braunkohle Szenario flexibel" (Number): Power from brown coal plants, constant power supply excluded 
        "Steinkohle Szenario" (Number): Power from hard coal plants
        "Import" (Number): Imported power
        "Gasturbinen" (Number): Power from gas plants
        "Kernenergie Szenario" (Number): Power from nuclear plants
        "Sonstige BackUp Kraftwerke" (Number): Power from other power plants 
        "Anteil PV und Wind" (Number): Ratio of power from wind and PV plants and demand (plus power used to charge storage)
        "Anteil PV und Wind ohne Laden" (Number): Ratio of power from wind and PV plants and demand
        "Anteil Alle" (Number): Ratio of all power suppliers and demand
        "Anteil Konventionelle Backup" (Number): Ratio of fossil and nuclear power suppliers and demand
        "Anteil Erneuerbare plus Grundlast" (Number): Ratio of renewable power suppliers, nuclear power and constant brown coal power and demand, 
        "Residual Mix" (Number): Demand - all power supplied
        "Residual Wind PV Szenario" (Number): Demand - power supplied by wind and PV plants
        "Residual EEG Szenario" (Number): Demand - power supplied by renewable suppliers, nuclear power and constant brown coal power
        "Lücke" (Number): Total demand not covered by suppliers
    */
    var data_scenario = [...data];
    // Consider selected years only
    data_scenario = data_scenario.filter((entry) => years.includes(entry["Date"].slice(0,4)))
    // Compute percentage of increase power demand given assumed total power demand 
    var increase_power = compute_increase_ratio(data_scenario, demand_per_year, years);
    // From GW to MW  
    pump_storage_capacity = pump_storage_capacity*1000;
    battery_storage_capacity = battery_storage_capacity*1000;
    battery_storage_power = battery_storage_power*1000;
    gas_power_installed= gas_power_installed*1000;
    pump_storage_power = pump_storage_power*1000; 
    import_europe = import_europe*1000;
    brown_coal_installed = brown_coal_installed*1000;
    hard_coal_installed = hard_coal_installed*1000;
    other_power_plants_installed = other_power_plants_installed*1000
    flexibility = flexibility*1000
    // initialize storage
    var storage_pump_storage = 0.5*pump_storage_capacity;
    var storage_battery = 0.5*battery_storage_capacity;
    // declare variable used during computation of power supply 
    var brown_coal_ground = 0.2*brown_coal_installed; 
    var max_brown_coal_flexible = brown_coal_installed - brown_coal_ground;
    var gas_power_needed;
    var brown_coal_power_needed; 
    var hard_coal_power_needed; 
    var import_europe_needed; 
    var other_power_plants_needed;
    var power_solar;
    var power_wind_offshore; 
    var power_wind_onshore;
    var power_wind_solar; 
    var power_from_storage;
    var power_from_storage_battery;
    var energy_used_to_fill_battery;
    var left_from_filling_battery;
    var energy_used_to_fill_pump_storage;
    var residual_with_additional_battery_storage;
    var residual_with_additional_storage;
    var residual_demand_power_wind_solar;
    var residual_with_additional_brown_coal;
    var residual_with_additional_hard_coal;
    var residual_with_additional_gas;
    var residual_with_additional_other_power_plants;
    var power_left_for_electrolysis;
    var residual_with_additional_import;
    // compute wind and solar power and the residual before demand side management 
    data_scenario.forEach(timestamp => {
        power_solar = (1.0*timestamp["Photovoltaik[MWh]"]/timestamp["Photovoltaik installiert"])*photovoltaik_installed*1000*solar_wind_technology_factor[0];
        power_wind_offshore = (1.0*timestamp["Wind Offshore[MWh]"]/timestamp["Wind Offshore installiert"])*wind_offshore_installed*1000*solar_wind_technology_factor[2];
        power_wind_onshore = (1.0*timestamp["Wind Onshore[MWh]"]/timestamp["Wind Onshore installiert"])*wind_onshore_installed*1000*solar_wind_technology_factor[1];
        power_wind_solar = power_solar + power_wind_offshore + power_wind_onshore;
        timestamp["Residual vor DSM"] = Number(timestamp["Gesamt[MWh]"])*increase_power*1.000000000001 - power_wind_solar;
        timestamp["Photovoltaik Szenario"] = power_solar;
        timestamp["Wind Offshore Szenario"] = power_wind_offshore;
        timestamp["Wind Onshore Szenario"] = power_wind_onshore;
        timestamp["PV und Wind"] = power_wind_solar;
        timestamp["Bedarf"] = Number(timestamp["Gesamt[MWh]"])*increase_power;
    });
    // Compute demand side management (DSM)
    data_scenario = compute_dsm(data_scenario, flexibility, "Residual vor DSM", "Bedarf");

    if (storage_management_parameter == "Residuallastminimierung") {
        console.log("Speichermanagement: Residuallastminimierung");
        data_scenario.forEach(timestamp => {  
            // charge storage if residual is smaller than average residual
            if (timestamp["Residuallast Abweichung"] < 0) {
                if (battery_storage_capacity < storage_battery + 0.8*Math.min(battery_storage_power, -1.0*timestamp["Residuallast Abweichung"])) { 
                    energy_used_to_fill_battery = (battery_storage_capacity - storage_battery)/0.8; 
                    storage_battery = battery_storage_capacity;
                    }  
                else {
                    energy_used_to_fill_battery = Math.min(battery_storage_power, -1.0*timestamp["Residuallast Abweichung"])
                    storage_battery += 0.8*Math.min(battery_storage_power, -1.0*timestamp["Residuallast Abweichung"])
                }
                left_from_filling_battery = -1.0*timestamp["Residuallast Abweichung"] - energy_used_to_fill_battery;
                //fill pump storage? 
                if (pump_storage_capacity < storage_pump_storage + 0.8*Math.min(pump_storage_power, left_from_filling_battery)) { 
                    energy_used_to_fill_pump_storage = (pump_storage_capacity - storage_pump_storage)/0.8; 
                    storage_pump_storage = pump_storage_capacity;
                }  
                else {
                    energy_used_to_fill_pump_storage = Math.min(pump_storage_power, left_from_filling_battery);
                    storage_pump_storage += 0.8*Math.min(pump_storage_power, left_from_filling_battery);
                }     
                timestamp["Speicherenergie Pumpspeicher"] = 0; 
                timestamp["Speicherenergie Batterien"] = 0;
                timestamp["Bedarf und Laden"] = Number(timestamp["Bedarf nach DSM"]) + energy_used_to_fill_battery + energy_used_to_fill_pump_storage; 
            }
            // use storage to balance the residual 
            else {
                // can we obtain the average residual by using battery storage only?  
                if (timestamp["Residuallast Abweichung"] <= Math.min(storage_battery, battery_storage_power)) {
                    power_from_storage_battery = timestamp["Residuallast Abweichung"]; 
                    storage_battery -= timestamp["Residuallast Abweichung"];
                    power_from_storage = 0;
                }
                // if not, add pump storage 
                else {
                    residual_with_additional_battery_storage = timestamp["Residuallast Abweichung"] - Math.min(storage_battery, battery_storage_power);
                    power_from_storage_battery = Math.min(storage_battery, battery_storage_power);
                    storage_battery -= Math.min(storage_battery, battery_storage_power)
                    if (residual_with_additional_battery_storage <= Math.min(storage_pump_storage, pump_storage_power)) {
                        power_from_storage = residual_with_additional_battery_storage; 
                        storage_pump_storage -= residual_with_additional_battery_storage;
                    }     
                    else {
                        power_from_storage = Math.min(storage_pump_storage, pump_storage_power); 
                        storage_pump_storage -= Math.min(storage_pump_storage, pump_storage_power);
                    }
                }
                timestamp["Speicherenergie Pumpspeicher"] = power_from_storage; 
                timestamp["Speicherenergie Batterien"] = power_from_storage_battery;
                timestamp["Bedarf und Laden"] = Number(timestamp["Bedarf nach DSM"]);    
            }
        });
        // Iterate a second time and cover demand with supply w.r.t. given order of suppliers
        data_scenario.forEach(timestamp => {
            power_wind_solar =  Number(timestamp["PV und Wind"]);
            residual_demand_power_wind_solar = timestamp["Bedarf und Laden"]*1.000000000001 - brown_coal_ground - power_wind_solar - Number(timestamp["Biomasse[MWh]"]) - Number(timestamp["Wasserkraft[MWh]"]) -
            Number(timestamp["Sonstige Erneuerbare[MWh]"]) - (1.0*timestamp["Kernenergie[MWh]"]/timestamp["Kernenergie installiert"])*nuclear_power_installed*1000 - timestamp["Speicherenergie Pumpspeicher"] - timestamp["Speicherenergie Batterien"];
            // More renewable + storage + ground power than needed -> produce hydrogen
            if (residual_demand_power_wind_solar < 0) {
                gas_power_needed = 0;
                hard_coal_power_needed = 0;
                brown_coal_power_needed = brown_coal_ground;
                import_europe_needed = 0; 
                other_power_plants_needed = 0;
                timestamp["Leistung Elektrolyseure"] = Math.min(-1.0*residual_demand_power_wind_solar, electrolysis_power_installed * 1000);
                timestamp["Ungenutzter Überschuss"] = -1.0*residual_demand_power_wind_solar -  timestamp["Leistung Elektrolyseure"]
            }
            // Less renewable than needed. Fill gap according to priority. Assumption: brown coal-hard coal-gas-import
            else {
                timestamp["Leistung Elektrolyseure"] = 0;
                timestamp["Ungenutzter Überschuss"] = 0;
                if (residual_demand_power_wind_solar <= max_brown_coal_flexible) {
                    brown_coal_power_needed = brown_coal_ground + residual_demand_power_wind_solar; 
                    hard_coal_power_needed = 0;
                    import_europe_needed = 0;
                    gas_power_needed = 0; 
                    other_power_plants_needed = 0;
                }
                // add hard coal
                else {
                    residual_with_additional_brown_coal = residual_demand_power_wind_solar - max_brown_coal_flexible; 
                    brown_coal_power_needed = brown_coal_ground + max_brown_coal_flexible;
                    if (residual_with_additional_brown_coal <= hard_coal_installed) {
                        hard_coal_power_needed = residual_with_additional_brown_coal;
                        import_europe_needed = 0;
                        gas_power_needed = 0; 
                        other_power_plants_needed = 0;
                    }  
                    // add first portion of gas 
                    else {
                        residual_with_additional_hard_coal = residual_with_additional_brown_coal - hard_coal_installed;
                        hard_coal_power_needed = hard_coal_installed; 
                        if (residual_with_additional_hard_coal <= gas_power_installed*utilized_capacity_gas_before_other_and_import) {
                            gas_power_needed = residual_with_additional_hard_coal;
                            import_europe_needed = 0; 
                            other_power_plants_needed = 0;
                        }
                        // add other power plants
                        else {
                            residual_with_additional_gas = residual_with_additional_hard_coal - gas_power_installed*utilized_capacity_gas_before_other_and_import;
                            gas_power_needed = gas_power_installed*utilized_capacity_gas_before_other_and_import;
                            if (residual_with_additional_gas <= other_power_plants_installed) {
                                other_power_plants_needed  = residual_with_additional_gas;
                                import_europe_needed = 0;
                            }
                            // add imports
                            else {
                                residual_with_additional_other_power_plants = residual_with_additional_gas - other_power_plants_installed;
                                other_power_plants_needed = other_power_plants_installed; 
                                if (residual_with_additional_other_power_plants <= import_europe){
                                    import_europe_needed = residual_with_additional_other_power_plants
                                }
                                else{
                                    residual_with_additional_import = residual_with_additional_other_power_plants-import_europe
                                    import_europe_needed = import_europe;
                                    if (residual_with_additional_import <= gas_power_installed*(1-utilized_capacity_gas_before_other_and_import)){
                                        gas_power_needed += residual_with_additional_import
                                    }
                                    else {
                                      gas_power_needed = gas_power_installed;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            timestamp["Braunkohle Szenario"] = brown_coal_power_needed;
            timestamp["Braunkohle Szenario flexibel"] = brown_coal_power_needed - brown_coal_ground;
            timestamp["Steinkohle Szenario"] = hard_coal_power_needed;
            timestamp["Import"] = import_europe_needed;
            timestamp["Gasturbinen"] = gas_power_needed;
            timestamp["Kernenergie Szenario"] = (1.0*timestamp["Kernenergie[MWh]"]/timestamp["Kernenergie installiert"])*nuclear_power_installed*1000;
            timestamp["Sonstige BackUp Kraftwerke"] = other_power_plants_needed;
            timestamp["Anteil PV und Wind"] = 1.0*power_wind_solar/timestamp["Bedarf und Laden"];
            timestamp["Anteil PV und Wind ohne Laden"] = 1.0*power_wind_solar/Number(timestamp["Bedarf nach DSM"]);
            timestamp["Anteil Alle"] = 1.0*(power_wind_solar + brown_coal_power_needed + hard_coal_power_needed + gas_power_needed + timestamp["Speicherenergie Pumpspeicher"] + timestamp["Speicherenergie Batterien"] + import_europe_needed + Number(timestamp["Biomasse[MWh]"]) + 
                                            Number(timestamp["Wasserkraft[MWh]"]) + Number(timestamp["Sonstige Erneuerbare[MWh]"])+ 
                                            timestamp["Kernenergie Szenario"]+other_power_plants_needed)/(timestamp["Bedarf und Laden"]);
            timestamp["Anteil Konventionelle Backup"] = 1.0*(brown_coal_power_needed - brown_coal_ground + hard_coal_power_needed + gas_power_needed +other_power_plants_needed)/(timestamp["Bedarf und Laden"]);     
            timestamp["Anteil Erneuerbare plus Grundlast"] = 1.0*(power_wind_solar + Number(timestamp["Biomasse[MWh]"]) + 
                                                    Number(timestamp["Wasserkraft[MWh]"]) + Number(timestamp["Sonstige Erneuerbare[MWh]"]) + 
                                                    timestamp["Speicherenergie Pumpspeicher"] + timestamp["Speicherenergie Batterien"] + brown_coal_ground+timestamp["Kernenergie Szenario"])/(timestamp["Bedarf und Laden"]);
            timestamp["Residual Mix"] = timestamp["Bedarf und Laden"] - timestamp["Anteil Alle"] * (timestamp["Bedarf und Laden"]);
            timestamp["Residual Wind PV Szenario"] = timestamp["Bedarf und Laden"] - power_wind_solar;
            timestamp["Residual EE Szenario"] = timestamp["Bedarf und Laden"] - timestamp["Anteil Erneuerbare plus Grundlast"]*timestamp["Bedarf und Laden"];
            if (timestamp["Anteil Alle"] < 1){
              timestamp["Lücke"] = (1-timestamp["Anteil Alle"]) * timestamp["Bedarf und Laden"];
            }
            else {
              timestamp["Lücke"] = 0;
            }
        });
    }
    // Charge storage only if supply exceeds demand
    else {
        data_scenario.forEach(timestamp => {
            power_wind_solar =  Number(timestamp["PV und Wind"]);
            residual_demand_power_wind_solar = timestamp["Bedarf nach DSM"]*1.000000000001 - brown_coal_ground -  power_wind_solar - Number(timestamp["Biomasse[MWh]"]) - Number(timestamp["Wasserkraft[MWh]"]) -
            Number(timestamp["Sonstige Erneuerbare[MWh]"]) - (1.0*timestamp["Kernenergie[MWh]"]/timestamp["Kernenergie installiert"])*nuclear_power_installed*1000;
            // More renewable than needed
            if (residual_demand_power_wind_solar < 0) {
                gas_power_needed = 0;
                hard_coal_power_needed = 0;
                brown_coal_power_needed = brown_coal_ground;
                import_europe_needed = 0; 
                power_from_storage_battery = 0;
                power_from_storage = 0;
                other_power_plants_needed = 0;
                // fill storage, battery first, pump storage second
                if (battery_storage_capacity < storage_battery + 0.8*Math.min(battery_storage_power, -1.0*residual_demand_power_wind_solar)) { 
                    energy_used_to_fill_battery = (battery_storage_capacity - storage_battery)/0.8; 
                    storage_battery = battery_storage_capacity;
                }  
                else {
                    energy_used_to_fill_battery = Math.min(battery_storage_power, -1.0*residual_demand_power_wind_solar)
                    storage_battery += 0.8*Math.min(battery_storage_power, -1.0*residual_demand_power_wind_solar)
                }
                left_from_filling_battery = -1.0*residual_demand_power_wind_solar - energy_used_to_fill_battery;
                //fill pump storage? 
                if (pump_storage_capacity < storage_pump_storage + 0.8*Math.min(pump_storage_power, left_from_filling_battery)) { 
                    energy_used_to_fill_pump_storage = (pump_storage_capacity - storage_pump_storage)/0.8; 
                    storage_pump_storage = pump_storage_capacity;
                }  
                else {
                    energy_used_to_fill_pump_storage = Math.min(pump_storage_power, left_from_filling_battery);
                    storage_pump_storage += 0.8*Math.min(pump_storage_power, left_from_filling_battery);
                }     
        
                power_left_for_electrolysis = -1.0*residual_demand_power_wind_solar - energy_used_to_fill_battery - energy_used_to_fill_pump_storage;
                timestamp["Leistung Elektrolyseure"] = Math.min(power_left_for_electrolysis, electrolysis_power_installed * 1000);
                timestamp["Ungenutzter Überschuss"] = power_left_for_electrolysis - timestamp["Leistung Elektrolyseure"];
            }
            // Less renewable than needed. Fill gap according to priority. Assumption: storage-brown coal-hard coal-gas-import
            else {
                energy_used_to_fill_battery = 0;
                energy_used_to_fill_pump_storage = 0;
                timestamp["Ungenutzter Überschuss"] = 0;
                timestamp["Leistung Elektrolyseure"] = 0;
                // add battery strorage 
                if (residual_demand_power_wind_solar <= Math.min(storage_battery, battery_storage_power)) {
                    power_from_storage_battery = residual_demand_power_wind_solar; 
                    storage_battery -= residual_demand_power_wind_solar;
                    power_from_storage = 0;
                    brown_coal_power_needed = brown_coal_ground;
                    hard_coal_power_needed = 0;
                    import_europe_needed = 0;
                    gas_power_needed = 0; 
                    other_power_plants_needed = 0;
                }
                // add pump storage 
                else {
                    residual_with_additional_battery_storage = residual_demand_power_wind_solar - Math.min(storage_battery, battery_storage_power);
                    power_from_storage_battery = Math.min(storage_battery, battery_storage_power);
                    storage_battery -= Math.min(storage_battery, battery_storage_power)
                    if (residual_with_additional_battery_storage <= Math.min(storage_pump_storage, pump_storage_power)) {
                        power_from_storage = residual_with_additional_battery_storage; 
                        storage_pump_storage -= residual_with_additional_battery_storage;
                        brown_coal_power_needed = brown_coal_ground;
                        hard_coal_power_needed = 0;
                        import_europe_needed = 0;
                        gas_power_needed = 0; 
                        other_power_plants_needed = 0;
                    }  
                        // add brown coal 
                    else {
                        residual_with_additional_storage = residual_with_additional_battery_storage - Math.min(storage_pump_storage, pump_storage_power);
                        power_from_storage = Math.min(storage_pump_storage, pump_storage_power); 
                        storage_pump_storage -= Math.min(storage_pump_storage, pump_storage_power);
                        if (residual_with_additional_storage <= max_brown_coal_flexible) {
                            brown_coal_power_needed = brown_coal_ground + residual_with_additional_storage; 
                            hard_coal_power_needed = 0;
                            import_europe_needed = 0;
                            gas_power_needed = 0; 
                            other_power_plants_needed = 0;
                        }
                        // add hard coal
                        else {
                            residual_with_additional_brown_coal = residual_with_additional_storage - max_brown_coal_flexible; 
                            brown_coal_power_needed = brown_coal_ground + max_brown_coal_flexible;
                            if (residual_with_additional_brown_coal <= hard_coal_installed) {
                                hard_coal_power_needed = residual_with_additional_brown_coal;
                                import_europe_needed = 0;
                                gas_power_needed = 0; 
                                other_power_plants_needed = 0;
                            }  
                            // add gas 
                            else {
                                residual_with_additional_hard_coal = residual_with_additional_brown_coal - hard_coal_installed;
                                hard_coal_power_needed = hard_coal_installed; 
                                if (residual_with_additional_hard_coal <= gas_power_installed*utilized_capacity_gas_before_other_and_import) {
                                    gas_power_needed = residual_with_additional_hard_coal;
                                    import_europe_needed = 0; 
                                    other_power_plants_needed = 0;
                                }
                                // add other power plants
                                else {
                                    residual_with_additional_gas = residual_with_additional_hard_coal - gas_power_installed*utilized_capacity_gas_before_other_and_import;
                                    gas_power_needed = gas_power_installed*utilized_capacity_gas_before_other_and_import;
                                    if (residual_with_additional_gas <= other_power_plants_installed) {
                                        other_power_plants_needed  = residual_with_additional_gas;
                                        import_europe_needed = 0;
                                    }
                                    // add imports
                                    else {
                                        residual_with_additional_other_power_plants = residual_with_additional_gas - other_power_plants_installed;
                                        other_power_plants_needed = other_power_plants_installed; 
                                        if (residual_with_additional_other_power_plants <= import_europe){
                                            import_europe_needed = residual_with_additional_other_power_plants
                                        }
                                        else{
                                            residual_with_additional_import = residual_with_additional_other_power_plants-import_europe
                                            import_europe_needed = import_europe;
                                            if (residual_with_additional_import <= gas_power_installed*(1-utilized_capacity_gas_before_other_and_import)){
                                                gas_power_needed += residual_with_additional_import
                                            }
                                            else {
                                              gas_power_needed = gas_power_installed;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }        
            timestamp["Bedarf und Laden"] = Number(timestamp["Bedarf nach DSM"]) + energy_used_to_fill_battery + energy_used_to_fill_pump_storage; 
            timestamp["Braunkohle Szenario"] = brown_coal_power_needed;
            timestamp["Braunkohle Szenario flexibel"] = brown_coal_power_needed - brown_coal_ground;
            timestamp["Steinkohle Szenario"] = hard_coal_power_needed;
            timestamp["Speicherenergie Pumpspeicher"] = power_from_storage; 
            timestamp["Speicherenergie Batterien"] = power_from_storage_battery;
            timestamp["Import"] = import_europe_needed;
            timestamp["Gasturbinen"] = gas_power_needed;
            timestamp["Kernenergie Szenario"] = (1.0*timestamp["Kernenergie[MWh]"]/timestamp["Kernenergie installiert"])*nuclear_power_installed*1000;
            timestamp["Sonstige BackUp Kraftwerke"] = other_power_plants_needed;
            timestamp["Anteil PV und Wind"] = 1.0*power_wind_solar/timestamp["Bedarf und Laden"];
            timestamp["Anteil PV und Wind ohne Laden"] = 1.0*power_wind_solar/Number(timestamp["Bedarf nach DSM"]);
            timestamp["Anteil Alle"] = 1.0*(power_wind_solar + brown_coal_power_needed + hard_coal_power_needed + gas_power_needed + power_from_storage +  
                                            power_from_storage_battery + import_europe_needed + Number(timestamp["Biomasse[MWh]"]) + 
                                            Number(timestamp["Wasserkraft[MWh]"]) + Number(timestamp["Sonstige Erneuerbare[MWh]"])+ 
                                            timestamp["Kernenergie Szenario"]+other_power_plants_needed)/(timestamp["Bedarf und Laden"]);
            timestamp["Anteil Konventionelle Backup"] = 1.0*(brown_coal_power_needed - brown_coal_ground + hard_coal_power_needed + gas_power_needed+other_power_plants_needed)/(timestamp["Bedarf und Laden"]);     

            timestamp["Anteil Erneuerbare plus Grundlast"] = 1.0*(power_wind_solar + Number(timestamp["Biomasse[MWh]"]) + 
                                                    Number(timestamp["Wasserkraft[MWh]"]) + Number(timestamp["Sonstige Erneuerbare[MWh]"]) + 
                                                    power_from_storage + power_from_storage_battery + brown_coal_ground+timestamp["Kernenergie Szenario"])/(timestamp["Bedarf und Laden"]);
            timestamp["Residual Mix"] = timestamp["Bedarf und Laden"] - timestamp["Anteil Alle"] * (timestamp["Bedarf und Laden"]);
            timestamp["Residual Wind PV Szenario"] = timestamp["Bedarf und Laden"] - power_wind_solar;
            timestamp["Residual EE Szenario"] = timestamp["Bedarf und Laden"] - timestamp["Anteil Erneuerbare plus Grundlast"]*timestamp["Bedarf und Laden"];
            if (timestamp["Anteil Alle"] < 1){
              timestamp["Lücke"] = (1-timestamp["Anteil Alle"]) * timestamp["Bedarf und Laden"];
            }
            else {
              timestamp["Lücke"] = 0;
            }
        });
    }    
    return data_scenario;
}
)}

function _data_filter(){return(
function data_filter(data, threshold_min, threshold_max, column) {
  /**
  Return data where the values of the specified column are between the given minimal and maximal threshold 
  */
  return data.filter((entry) => threshold_min <= Number(entry[column])   &&  entry[column] <= Number(threshold_max));
}
)}

function _compute_dunkelflauten(_,moment,substract,rounding,get_year_index){return(
function(data, duration, extraction_mode, compute_heat_map_data) {
 /**
 Compute the events ("Dunkelflauten") of a minimal given duration. The given data is already filtered, that is, it contains only the hours where the given criterium is met. 
 Args:
      data (Array[JSON]): Data of the demand and the power generation. Each entry of the array contains data of one specific hour where the filter 
      criterim is met. 
      duration (Number): Mimimum Duration of an event
      extraction_mode (String): Specifies if information is extracted for part one ("history") or for part two ("scenario")  
      compute_heat_map_data (Boolen): Computes data to plot as heat map if true
   Returns:
      dunkelflaute_start (Array): Start dates of the events
      dunkelflaute_duration (Array): Durations of the events
      dunkelflaute_heat_map_data (Array(String, Number, Number): Array for heat map (Date: MM-DD, index of the year, value: 0-24)
      dunkelflaute_table_information Array(JSON): Information for each event, for instance minimum power of wind and soloar plants
      dunkelflaute_of_maximum_duration [String, Number]: Start date and duratio of longest event
 */
  var dunkelflaute_start = [];
  var dunkelflaute_duration = [];
  var dunkelflaute_heat_map_data = [];
  var considered_days= [];
  var dunkelflaute_table_information = [];

  var current_batch_number = 0;
  var batch_correspondence = [];
  var current_batch_length = 1;
  var batch_length = [];
  var all_dates = _.pluck(data, "Date").map(String);
  // if filter criterium is never met, return empty arrays
  if (all_dates.length == 0){
      return [dunkelflaute_start, dunkelflaute_duration,dunkelflaute_heat_map_data, dunkelflaute_table_information];
  }
  var all_dates_unix = _.pluck(data, "Unix Time Stamp").map(Number);
  var first_unix_timestamp = all_dates_unix[0];
  var distance_time = 0;
  // Compute batches of consecutive hours:
  // Check distance between two consecutive data points. If the distance is greater than one hour, start a new batch. Store the size of the current batch and reset the counter. 
  for (var i = 0; i < all_dates.length - 1; i++) {
      distance_time = all_dates_unix[i+1] - all_dates_unix[i];
      if (distance_time > 3600) {
          batch_length.push(current_batch_length);
          batch_correspondence.push(current_batch_number);
          current_batch_length = 1;
          current_batch_number += 1; 
      }
      else {
          batch_correspondence.push(current_batch_number);
          current_batch_length += 1; 
      }  
  }
  // handle last batch
  batch_length.push(current_batch_length);
  batch_correspondence.push(current_batch_number)
  
  //Filter all batches of length at least "duration"
  var start_date_index = 0;
  var dunkelflaute_start_unix;

  var dunkelflaute_of_maximum_duration;
  var maximum_duration = 0;
  
  batch_length.forEach(function(element) { 
    var rest_of_day;
    var number_of_full_days;
    var rest_of_dunkelflaute; 
    var heat_map_start_day;
    var heat_map_start_day_duration;
    var heat_map_start_day_rest_of_day;
    var day_year;
    var day_year_data;
    var time_stamp;

    if (element >= duration) {
      // add length and start data of dunkelflaute to arrays
      dunkelflaute_duration.push(element);
      dunkelflaute_start_unix = all_dates_unix[start_date_index];
      dunkelflaute_start.push(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').format("YYYY/MM/DD HH:mm"))
      
      // compute all relevant information of the dunkelflaute 
      if (extraction_mode == "history") {
        var data_during_dunkelflaute = data.slice(start_date_index,start_date_index+element);
        var percentage_wind_pv = _.pluck(data_during_dunkelflaute, "Anteil an Verbrauch Wind PV").map(Number);
        var demand_data = _.pluck(data_during_dunkelflaute, "Gesamt[MWh]").map(Number)
        var demand = demand_data.reduce((pv, cv) => pv + cv, 0)/1000.0;
        var residual_data = _.pluck(data_during_dunkelflaute, "Residual PV Wind").map(Number);
        var solar_wind = substract(demand_data, residual_data)
        var residual_renewable = _.pluck(data_during_dunkelflaute, "Residual EEG").map(Number).reduce((pv, cv) => pv + cv, 0);
        dunkelflaute_table_information.push({
          "Datum": all_dates[start_date_index],
          "Dauer in Stunden": element,
          "Wind und PV Mimimum (GW)": rounding(Math.min(...solar_wind)/1000,2), 
          "Wind und PV Durchschnitt (GW)": rounding(solar_wind.reduce((pv, cv) => pv + cv, 0)/1000/element,2),
          "Maximale Residuallast (GW)": rounding(Math.max(...residual_data)/1000,2).toLocaleString('de') ,
       });
      }
      else if (extraction_mode == "scenario") {
        var data_during_dunkelflaute = data.slice(start_date_index,start_date_index+element);
        var percentage_wind_pv = _.pluck(data_during_dunkelflaute, "Anteil PV und Wind").map(Number);     
        var wind_pv = _.pluck(data_during_dunkelflaute, "PV und Wind").map(Number);     
        var residual_data = _.pluck(data_during_dunkelflaute, "Residual Wind PV Szenario").map(Number);
        var residual = residual_data.reduce((pv, cv) => pv + cv, 0);
        var residual_renewable = _.pluck(data_during_dunkelflaute, "Residual EEG Szenario").map(Number).reduce((pv, cv) => pv + cv, 0);
        var total = _.pluck(data_during_dunkelflaute, "Bedarf und Laden").map(Number).reduce((pv, cv) => pv + cv, 0);
        dunkelflaute_table_information.push({
          "Datum": all_dates[start_date_index],
          "Dauer in Stunden": element,   
          "Minimum Wind und PV (GW)": rounding(Math.min(...wind_pv)/1000,2),
          "Durchschnitt Wind und PV (GW)": rounding(wind_pv.reduce((pv, cv) => pv + cv, 0)/1000/element,2),
          "Maximale Residuallast (GW)": rounding(Math.max(...residual_data)/1000,2),
          "Maximale Versorgungslücke (GW)": Math.abs(rounding(Math.max(...(_.pluck(data_during_dunkelflaute, "Residual Mix").map(Number)))/1000,2))
       });
          
      } 
      // compute heat map value for all days a dunkelflaute consists of 
      if (compute_heat_map_data) {
        rest_of_day = 24 - moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').hour();
        // initialize entry in heat map
        heat_map_start_day = String(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').dayOfYear()-1) + "-" + 
        String(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').year());
        heat_map_start_day_duration = [moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').dayOfYear()-1, 
                                       get_year_index(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').year()), element];
        heat_map_start_day_rest_of_day = [moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').dayOfYear()-1, 
                                          get_year_index(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').year()), rest_of_day];
        // handle dunkelflaute if duration is at most rest of day
        if (rest_of_day >= element) {
          if (considered_days.includes(heat_map_start_day)) {
            dunkelflaute_heat_map_data[considered_days.indexOf(heat_map_start_day)][2] += element;
          }
          else {
            dunkelflaute_heat_map_data.push(heat_map_start_day_duration);
            considered_days.push(heat_map_start_day);
          }
        }
        // handle dunkelflaute if duration is longer than rest of day
        else {
          number_of_full_days = Math.floor(1.0*(element - rest_of_day)/24); 
          rest_of_dunkelflaute  = (element - rest_of_day) % 24;
          if (considered_days.includes(heat_map_start_day)) {
            dunkelflaute_heat_map_data[considered_days.indexOf(heat_map_start_day)][2] += rest_of_day;

          }
          else {
            dunkelflaute_heat_map_data.push(heat_map_start_day_rest_of_day);
            considered_days.push(heat_map_start_day);
          }
          // set heat map data to 24 our for all days fully included in the dunkelflaute
          for (i = 1; i <= number_of_full_days; i++) {
            time_stamp = dunkelflaute_start_unix + 24*i*3600;
            day_year = String(moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1) + "-" + 
              String(moment.unix(time_stamp).tz('Europe/Berlin').year());
            day_year_data = [moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1, 
                             get_year_index(moment.unix(time_stamp).tz('Europe/Berlin').year()), 24];
            dunkelflaute_heat_map_data.push(day_year_data);
            // ensure that the indices of considerer_days and dunkelflaute_heat_map_data remain consistent 
            considered_days.push(day_year);
          }
          if (rest_of_dunkelflaute > 0) {
            time_stamp = dunkelflaute_start_unix + 24*(number_of_full_days+1)*3600;
            day_year = String(moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1) + "-" + 
              String(moment.unix(time_stamp).tz('Europe/Berlin').year());
            day_year_data = [moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1, 
                             get_year_index(moment.unix(time_stamp).tz('Europe/Berlin').year()), rest_of_dunkelflaute]
            dunkelflaute_heat_map_data.push(day_year_data);
            considered_days.push(day_year);   
          }  
        }
    }
      if (element > maximum_duration) {
        maximum_duration = element; 
        dunkelflaute_of_maximum_duration = [dunkelflaute_start_unix, element];

      }
    }
    start_date_index += element;
  });
  return [dunkelflaute_start, dunkelflaute_duration, dunkelflaute_heat_map_data, dunkelflaute_table_information, dunkelflaute_of_maximum_duration];
  }
)}

function _generate_analysis_scenario(_,data_filter,compute_dunkelflauten,ratio_renewable_import_parameter_function,$0){return(
function generate_analysis_scenario(data) {
  /**
  Analyis of the scenario. Compute values for the dynmaic text fields and the data for the plots 
    Args:
        data (Array[JSON]): Data of the demand and the power generation for the given scenario
    Returns:
        results (JSON): Values for the progress bar and data for the heat map
  */
  // extract all relevant data 
  var gas_power_commulative = _.pluck(data, "Gasturbinen").reduce((pv, cv) => pv + cv, 0);
  var total_power_consumed_by_electrolysis = _.pluck(data, "Leistung Elektrolyseure").reduce((pv, cv) => pv + cv, 0);
  var total_brown_coal = _.pluck(data, "Braunkohle Szenario").reduce((pv, cv) => pv + cv, 0);
  var total_hard_coal = _.pluck(data, "Steinkohle Szenario").reduce((pv, cv) => pv + cv, 0);
  var total_nuclear = _.pluck(data, "Kernenergie Szenario").reduce((pv, cv) => pv + cv, 0);
  var total_import = _.pluck(data, "Import").reduce((pv, cv) => pv + cv, 0);
  var total_demand_array = _.pluck(data, "Bedarf nach DSM").map(Number);
  var total_demand = total_demand_array.reduce((pv, cv) => pv + cv, 0);
  var total_gap = _.pluck(data, "Lücke").reduce((pv, cv) => pv + cv, 0);
  var total_others =  _.pluck(data, "Sonstige BackUp Kraftwerke").reduce((pv, cv) => pv + cv, 0); 
  var covered_demand_ratio = (total_demand - total_gap)/total_demand;
  var covered_demand = total_demand - total_gap;

  var covered_by_h4 = total_power_consumed_by_electrolysis*0.43*0.73/gas_power_commulative; 

  var residuals = _.pluck(data, "Residual Mix");
  var max_residual = Math.max(...residuals);
  
  // filter data w.r.t. to given range
  console.log("Start computing Coverage", total_gap) 
  var data_filtered = data_filter(data, 0, 1, "Anteil Alle");
  var dunkelflauten = compute_dunkelflauten(data_filtered, 1, "no table data", true);
  var heat_map_data = dunkelflauten[2];
  var total_time_within_threshold = data_filtered.length;   
  var ratio_hours_within_threshold = 1.0*total_time_within_threshold/data.length;
  
      if (covered_by_h4 < 1) {
      var total_fossil = (total_others + total_nuclear + total_hard_coal + total_brown_coal + (1-ratio_renewable_import_parameter_function)*total_import +  gas_power_commulative*(1-covered_by_h4));
    } 
    else {
    var total_fossil = (total_others + total_nuclear + total_hard_coal + total_brown_coal + (1-ratio_renewable_import_parameter_function)*total_import); 
    }
  console.log("Coverage computed")
    $0.value = "blinking";
       setTimeout(function () {
      $0.value = ""; 
      }, 3000)
console.log("Fossil", total_fossil, total_import)
  var result = {"coverage": ratio_hours_within_threshold,  "heatmap": heat_map_data, "fossil": total_fossil, "max_gap": max_residual, "coverage_ratio": covered_demand_ratio, "covered_demand": covered_demand, "bedarf_gesamt": total_demand};
  return result 
}
)}

function _plot_heat_map(dates_of_a_year_366,get_date_by_year_dayOfYear,draw_echart){return(
function plot_heat_map(data_to_be_plotted) {
 var days = dates_of_a_year_366;// Array.from(Array(367).keys()).map(String).slice(1,367);
 var years = ['2015', '2016', '2017',
        '2018', '2019', '2020', '2021'];

 var echartOptions = {
  title: {
    text: "Tage mit Versorgungslücken"
  },
   //toolbox: {
   //     feature: {
   //         restore: {},
   //         saveAsImage: {}
   //     }
   // },
   grid: {
  left: 40,
  top: 30,
  right: 80,
  bottom: 30
},
    tooltip: {
        position: 'top',
        formatter: function (params) {
        
        return  "Anzahl Stunden mit einer Versorgungslücke (" + get_date_by_year_dayOfYear(params.value[1], params.value[0])+ "): " + String(params.value[2]);
      }
        
        
    },
  
    xAxis: {
        type: 'category',
        data: days,
        splitArea: {
            show: true
        }
    },
    yAxis: {
        type: 'category',
        data: years,
        splitArea: {
            show: true
        }
    },
    visualMap: {
        min: 0,
        max: 24,
        calculable: true,
        orient: 'vertical',
        padding: [
    5,  // up
    0, // right
    25,  // down
    5, // left
],
        align: 'right', 
        left: '92%'
    },
   dataZoom: {
            type: 'inside',
            realtime: true,
            xAxisIndex: [0, 1]
   },
    series: [{
        name: 'Dunkelflauten',
        type: 'heatmap',
        data: data_to_be_plotted,
        label: {
            show: false
        },
        emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
        }
    }]
};
 return draw_echart(echartOptions, "heat_map", document.getElementsByClassName("observablehq")[0].parentElement.offsetWidth*0.6, 200)
}
)}

function _158(htl){return(
htl.html`<h3 class="hidden">Hilfsfunktionen</h3>`
)}

function _compute_class_coverage(rounding){return(
function compute_class_coverage(coverage) {
  if (rounding(100*coverage,1) >= 100) {
    return "progress-bar bg-success" 
  }
  else if (rounding(100*coverage,1) > 90){
    return "progress-bar bg-warning" 
  }
  else {
    return "progress-bar bg-danger" 
  }
}
)}

function _compute_class_renewable(rounding){return(
function compute_class_renewable(renewable) {
  if (rounding(100*renewable,1) >= 65) {
    return "progress-bar bg-success" 
  }
  else if (rounding(100*renewable,1) >= 55){
    return "progress-bar bg-warning" 
  }
  else {
    return "progress-bar bg-danger" 
  }
}
)}

function _substract(){return(
function substract(arr1, arr2) {
  let x = [];
  for(let i = 0;i<=arr2.length-1;i++)
  x.push(arr1[i] - arr2[i]);
  return(x)
}
)}

function _addition(){return(
function addition(arr1, arr2) {
  let x = [];
  for(let i = 0;i<=arr2.length-1;i++)
  x.push(arr1[i] + arr2[i]);
  return(x)
}
)}

function _second_max(){return(
function (arr){ 
    var max = Math.max.apply(null, arr), // get the max of the array
        maxi = arr.indexOf(max);
    arr[maxi] = -Infinity; // replace max in the array with -infinity
    var secondMax = Math.max.apply(null, arr); // get the new max 
    arr[maxi] = max;
    return secondMax;
}
)}

function _select_technology_value(scenario){return(
function select_technology_value(selection) {
  console.log("Selection", selection);
  if (selection == "Stand 2020"){
    return [1, 1, 1];
  }
  else if (selection == "Entwicklung 2030") {
    return [1.064516129, 1.107798165, 1.077402892];
  }
  else if (selection == "Entwicklung 2045") {
    return [1.066740823, 1.232798165, 1.056138361];
  }
  else if (selection == "Annahmen der Studie") {
    if (scenario == "knd_2030") {
      return  [1.064516129, 1.107798165, 1.077402892];
    }
    if (scenario == "knd_2045") {
      return [1.066740823, 1.232798165, 1.056138361];
    }
    if (scenario == "fraunhofer_2030") {
      return [1.160594528, 1.231422018, 1.160594528];
    }
    if (scenario == "fraunhofer_2050") {
      return [1.166997222, 1.50206422, 1.397748754];
    }
    if (scenario == "dena_2030") {
      return [1.044493882, 1.346330275, 1.146299972];
    }
    if (scenario == "dena_2045") {
      return [1.004449388, 1.401376147, 1.128437766];
    }
    if (scenario == "diw") {
      return [1.226918799, 2.017201835, 1.134108307];
    }
    if (scenario == "diw_des") {
      return [1.207452725, 2.09059633, 1.128437766];
    }
  }
}
)}

function _compute_increase_ratio(_){return(
function compute_increase_ratio(data, demand, years) {
  var demand_history = _.pluck(data, "Gesamt[MWh]").map(Number).reduce((pv, cv) => pv + cv, 0)/years.length/1000000;
  return 1.0*demand/demand_history;
}
)}

function _rounding(){return(
function rounding(number, precission) {
  var roundedString = parseFloat(number.toFixed(precission));
  return Number(roundedString);
}
)}

function _draw_echart(html,echarts){return(
function draw_echart(option, div_name, w, h) {
  var div = html`<div id=${div_name} style="width:${w}px;height:${h}px;" ></div>`;
  var chart = echarts.init(div);
  option && chart.setOption(option);
  
  return {
    rendered: div,
    chart_backend : chart,
    data: option
  }
}
)}

function _set(Event){return(
function set(input, value) {
  input.value = value;
  input.dispatchEvent(new Event("input"));
}
)}

function _get_year_index(){return(
function get_year_index(year) {
  switch (year) {
    case 2015: return 0;
    case 2016: return 1;
    case 2017: return 2;
    case 2018: return 3;
    case 2019: return 4; 
    case 2020: return 5;
    case 2021: return 6; 
    default: console.log("Invalid year");
  }
}
)}

function _getDates(moment){return(
function getDates(startDate, stopDate, format) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format(format) )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}
)}

function _get_date_by_year_dayOfYear(dates_of_a_year_366,dates_of_a_year_365){return(
function get_date_by_year_dayOfYear(year, day) {
  if ([1,5].includes(year)){
    return dates_of_a_year_366[day];
  }
  else {
    return dates_of_a_year_365[day];
  }
  
}
)}

function _get_date_by_year_day_full_date(dates_2015,dates_2016,dates_2017,dates_2018,dates_2019,dates_2020,dates_2021){return(
function get_date_by_year_day_full_date(year, day) {
  console.log("Year, DAY", year, day);
  switch (year) {
    case 0: return dates_2015[day];
    case 1: return dates_2016[day];
    case 2: return dates_2017[day];
    case 3: return dates_2018[day];
    case 4: return dates_2019[day]; 
    case 5: return dates_2020[day];
    case 6: return dates_2021[day];
    default: console.log("Invalid year");
  }
}
)}

function _173(htl){return(
htl.html`<h3 class="hidden">Event Handler</h3>`
)}

function _174(htl){return(
htl.html`<h2 class="hidden">Externe Bibliotheken</h2>`
)}

function __(require){return(
require('underscore')
)}

function _echarts(require){return(
require("https://cdn.jsdelivr.net/npm/echarts@5.1.2/dist/echarts.min.js")
)}

function _moment(require){return(
require('https://momentjs.com/downloads/moment-timezone-with-data-1970-2030.js')
)}

function _html(htl){return(
htl.html
)}

async function _179(require,FileAttachment){return(
require(await FileAttachment("bootstrap.bundle.min.js").url())
)}

function _bind(disposal,set,eventof,get){return(
function bind(input, view, invalidation = disposal(input)) {
  set(input, view.value);
  input[`on${eventof(input)}`] = () => view.value = get(input);
  const update = ({detail: value}) => get(input) === value || set(input, value);
  view.addEventListener("input", update);
  invalidation.then(() => view.removeEventListener("input", update));
  return input;
}
)}

function _eventof(){return(
function eventof(input) {
  switch (input.type) {
    case "button":
    case "submit": return "click";
    case "file": return "change";
    default: return "input";
  }
}
)}

function _get(){return(
function get(input) {
  switch (input.type) {
    case "range":
    case "number": return input.valueAsNumber;
    case "date": return input.valueAsDate;
    case "checkbox": return input.checked;
    case "file": return input.multiple ? input.files : input.files[0];
    default: return input.value;
  }
}
)}

function _View(bind){return(
class View {
  constructor(value) {
    Object.defineProperties(this, {
      _list: {value: [], writable: true},
      _value: {value, writable: true}
    });
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this.dispatchEvent(new CustomEvent("input", {detail: value}));
  }
  addEventListener(type, listener) {
    if (type != "input" || this._list.includes(listener)) return;
    this._list = [listener].concat(this._list);
  }
  removeEventListener(type, listener) {
    if (type != "input") return;
    this._list = this._list.filter(l => l !== listener);
  }
  dispatchEvent(event) {
    const p = Promise.resolve(event);
    this._list.forEach(l => p.then(l));
  }
  bind(input, invalidation) {
    return bind(input, this, invalidation);
  }
}
)}

export default function define(runtime, observer) {
  const main = runtime.module();
  const fileAttachments = new Map([["bootstrap.bundle.min.js",require("./files/6cf242ec4814aa1a5fc921cc2716bc2dec7e0a2a7e9461c38cd7c0b8e7ddd1a12a3ad5bf149de8883070dd679e0188e495b9ffabd4b06d05809cb06c1a7cbff8").default],
  ["bootstrap.min.css",require("./files/80206945fc27e5aee59fd4a195086df069c07913f8a998613025de3808d29c0a8477fc07c8ed314c28b499fbf0a83a9485c53d84e29141440bcef839ee731e66").default],
  ["Aller_Rg.ttf",require("./files/3a5e627d2f4d5dba36494fdb55f842eb546624689fda84f6e9bba634d3261521a2e09f6f45f1c8ebe5675ca7d68a9a45b4c17767da927fde2a182525b644b711").default],
  ["bg.jpg",require("./files/d78591527d28337968d24fb0dcb6a41ab9b07568da9d939c5919cc3837020a674856a41b627a326c936cb0f0b95846d2638a6ddabb0e253ac5ab5a50d7e88f7b").default],
  ["data_for_scenario_analysis@1.csv",require("./files/79f9e7754aac0c51cf115e8cbf4826cd8523db8ce24d30679350901aa0ed18c268e6976a63fd37e1b36d8cd13381867ec619dfb8103549217ce7dd0bf937d50a").default],
  ["grafik_ende_geschichte@6.jpg",require("./files/58829a067d60878be2a63b2988d2ab5a147769dd3aa8cfb46288e2620dbe7e008b3b928930452de0caf9ace16ab5f0c777a85cd93f9698b19cc7218f1e6b0a33").default]]);
  main.builtin("FileAttachment", runtime.fileAttachments(name => fileAttachments.get(name)));
  main.variable(observer()).define(["FileAttachment","start_journey_class_button","mutable start_journey_class_button","mutable demand_class","mutable start_text_class","mutable demand_class_button","plot_heat_map","results_analaysis_scenario","compute_class_coverage","coverage","rounding","coverage_ratio","compute_class_renewable","coverage_renewable","highlight_class","compare_class","demand_class","netto_parameter","flexibility_parameter","demand_class_button","set","mutable demand_result_class","mutable demand_result_class_button","mutable netto_parameter_function","mutable flexibility_parameter_function","demand_result_class","demand_result_class_button","mutable wind_pv_class","mutable wind_pv_class_button","wind_pv_class","wind_onshore_parameter","wind_offshore_parameter","photovoltaik_parameter","wind_pv_class_button","mutable wind_pv_unrealistic_class","mutable wind_pv_unrealistic_class_button","mutable wind_onshore_parameter_function","mutable wind_offshore_parameter_function","mutable photovoltaik_parameter_function","wind_pv_button_text","wind_pv_unrealistic_class","wind_pv_unrealistic_class_button","mutable nuclear_class","mutable nuclear_class_button","nuclear_class","nuclear_power_parameter","nuclear_class_button","mutable nuclear_result_class","mutable nuclear_result_class_button","mutable nuclear_power_parameter_function","nuclear_button_text","nuclear_result_class","nuclear_result_class_button","mutable coal_class","mutable coal_class_button","coal_class","brown_coal_power_parameter","hard_coal_power_parameter","coal_class_button","mutable coal_result_class","mutable coal_result_class_button","mutable brown_coal_power_parameter_function","mutable other_power_plants_parameter_function","mutable hard_coal_power_parameter_function","coal_button_text","coal_result_class","coal_result_class_button","mutable backup_class","mutable wind_pv_unrealistic_result_after_class_button","mutable backup_class_button","backup_class","imports_paramter","gas_power_parameter","electrolysis_parameter","backup_class_button","mutable backup_result_class","mutable backup_result_class_button","mutable imports_paramter_function","mutable gas_power_parameter_function","mutable electrolysis_parameter_function","mutable ratio_renewable_import_parameter_function","backup_result_class","backup_result_class_button","netto_parameter_copy","flexibility_parameter_copy","nuclear_power_parameter_copy","brown_coal_power_parameter_copy","hard_coal_power_parameter_copy","wind_onshore_parameter_copy","wind_offshore_parameter_copy","photovoltaik_parameter_copy","imports_paramter_copy","gas_power_parameter_copy","electrolysis_parameter_copy","ratio_renewable_import_parameter_copy","mutable mix_class","mutable extra_space","mutable compare_class","mix_class","htl"], _1);
  main.variable(observer()).define(["extra_space","htl"], _2);
  main.variable(observer()).define(["htl"], _3);
  main.variable(observer()).define(["htl"], _4);
  main.variable(observer()).define(["html","FileAttachment","width"], _5);
  main.define("initial compare_class", _compare_class);
  main.variable(observer("mutable compare_class")).define("mutable compare_class", ["Mutable", "initial compare_class"], (M, _) => new M(_));
  main.variable(observer("compare_class")).define("compare_class", ["mutable compare_class"], _ => _.generator);
  main.define("initial highlight_class", _highlight_class);
  main.variable(observer("mutable highlight_class")).define("mutable highlight_class", ["Mutable", "initial highlight_class"], (M, _) => new M(_));
  main.variable(observer("highlight_class")).define("highlight_class", ["mutable highlight_class"], _ => _.generator);
  main.define("initial extra_space", _extra_space);
  main.variable(observer("mutable extra_space")).define("mutable extra_space", ["Mutable", "initial extra_space"], (M, _) => new M(_));
  main.variable(observer("extra_space")).define("extra_space", ["mutable extra_space"], _ => _.generator);
  main.variable(observer("coverage")).define("coverage", ["rounding","results_analaysis_scenario"], _coverage);
  main.variable(observer("coverage_ratio")).define("coverage_ratio", ["rounding","results_analaysis_scenario"], _coverage_ratio);
  main.variable(observer("coverage_renewable")).define("coverage_renewable", ["rounding","results_analaysis_scenario"], _coverage_renewable);
  main.define("initial start_text_class", _start_text_class);
  main.variable(observer("mutable start_text_class")).define("mutable start_text_class", ["Mutable", "initial start_text_class"], (M, _) => new M(_));
  main.variable(observer("start_text_class")).define("start_text_class", ["mutable start_text_class"], _ => _.generator);
  main.define("initial nuclear_class", _nuclear_class);
  main.variable(observer("mutable nuclear_class")).define("mutable nuclear_class", ["Mutable", "initial nuclear_class"], (M, _) => new M(_));
  main.variable(observer("nuclear_class")).define("nuclear_class", ["mutable nuclear_class"], _ => _.generator);
  main.define("initial nuclear_result_class", _nuclear_result_class);
  main.variable(observer("mutable nuclear_result_class")).define("mutable nuclear_result_class", ["Mutable", "initial nuclear_result_class"], (M, _) => new M(_));
  main.variable(observer("nuclear_result_class")).define("nuclear_result_class", ["mutable nuclear_result_class"], _ => _.generator);
  main.define("initial start_journey_class_button", _start_journey_class_button);
  main.variable(observer("mutable start_journey_class_button")).define("mutable start_journey_class_button", ["Mutable", "initial start_journey_class_button"], (M, _) => new M(_));
  main.variable(observer("start_journey_class_button")).define("start_journey_class_button", ["mutable start_journey_class_button"], _ => _.generator);
  main.define("initial nuclear_class_button", _nuclear_class_button);
  main.variable(observer("mutable nuclear_class_button")).define("mutable nuclear_class_button", ["Mutable", "initial nuclear_class_button"], (M, _) => new M(_));
  main.variable(observer("nuclear_class_button")).define("nuclear_class_button", ["mutable nuclear_class_button"], _ => _.generator);
  main.define("initial nuclear_result_class_button", _nuclear_result_class_button);
  main.variable(observer("mutable nuclear_result_class_button")).define("mutable nuclear_result_class_button", ["Mutable", "initial nuclear_result_class_button"], (M, _) => new M(_));
  main.variable(observer("nuclear_result_class_button")).define("nuclear_result_class_button", ["mutable nuclear_result_class_button"], _ => _.generator);
  main.define("initial coal_class", _coal_class);
  main.variable(observer("mutable coal_class")).define("mutable coal_class", ["Mutable", "initial coal_class"], (M, _) => new M(_));
  main.variable(observer("coal_class")).define("coal_class", ["mutable coal_class"], _ => _.generator);
  main.define("initial coal_result_class", _coal_result_class);
  main.variable(observer("mutable coal_result_class")).define("mutable coal_result_class", ["Mutable", "initial coal_result_class"], (M, _) => new M(_));
  main.variable(observer("coal_result_class")).define("coal_result_class", ["mutable coal_result_class"], _ => _.generator);
  main.define("initial coal_class_button", _coal_class_button);
  main.variable(observer("mutable coal_class_button")).define("mutable coal_class_button", ["Mutable", "initial coal_class_button"], (M, _) => new M(_));
  main.variable(observer("coal_class_button")).define("coal_class_button", ["mutable coal_class_button"], _ => _.generator);
  main.define("initial coal_result_class_button", _coal_result_class_button);
  main.variable(observer("mutable coal_result_class_button")).define("mutable coal_result_class_button", ["Mutable", "initial coal_result_class_button"], (M, _) => new M(_));
  main.variable(observer("coal_result_class_button")).define("coal_result_class_button", ["mutable coal_result_class_button"], _ => _.generator);
  main.define("initial wind_pv_class", _wind_pv_class);
  main.variable(observer("mutable wind_pv_class")).define("mutable wind_pv_class", ["Mutable", "initial wind_pv_class"], (M, _) => new M(_));
  main.variable(observer("wind_pv_class")).define("wind_pv_class", ["mutable wind_pv_class"], _ => _.generator);
  main.define("initial wind_pv_class_button", _wind_pv_class_button);
  main.variable(observer("mutable wind_pv_class_button")).define("mutable wind_pv_class_button", ["Mutable", "initial wind_pv_class_button"], (M, _) => new M(_));
  main.variable(observer("wind_pv_class_button")).define("wind_pv_class_button", ["mutable wind_pv_class_button"], _ => _.generator);
  main.define("initial demand_class", _demand_class);
  main.variable(observer("mutable demand_class")).define("mutable demand_class", ["Mutable", "initial demand_class"], (M, _) => new M(_));
  main.variable(observer("demand_class")).define("demand_class", ["mutable demand_class"], _ => _.generator);
  main.define("initial demand_result_class", _demand_result_class);
  main.variable(observer("mutable demand_result_class")).define("mutable demand_result_class", ["Mutable", "initial demand_result_class"], (M, _) => new M(_));
  main.variable(observer("demand_result_class")).define("demand_result_class", ["mutable demand_result_class"], _ => _.generator);
  main.define("initial demand_class_button", _demand_class_button);
  main.variable(observer("mutable demand_class_button")).define("mutable demand_class_button", ["Mutable", "initial demand_class_button"], (M, _) => new M(_));
  main.variable(observer("demand_class_button")).define("demand_class_button", ["mutable demand_class_button"], _ => _.generator);
  main.define("initial demand_result_class_button", _demand_result_class_button);
  main.variable(observer("mutable demand_result_class_button")).define("mutable demand_result_class_button", ["Mutable", "initial demand_result_class_button"], (M, _) => new M(_));
  main.variable(observer("demand_result_class_button")).define("demand_result_class_button", ["mutable demand_result_class_button"], _ => _.generator);
  main.define("initial start_text_class_button", _start_text_class_button);
  main.variable(observer("mutable start_text_class_button")).define("mutable start_text_class_button", ["Mutable", "initial start_text_class_button"], (M, _) => new M(_));
  main.variable(observer("start_text_class_button")).define("start_text_class_button", ["mutable start_text_class_button"], _ => _.generator);
  main.define("initial backup_class", _backup_class);
  main.variable(observer("mutable backup_class")).define("mutable backup_class", ["Mutable", "initial backup_class"], (M, _) => new M(_));
  main.variable(observer("backup_class")).define("backup_class", ["mutable backup_class"], _ => _.generator);
  main.define("initial backup_result_class", _backup_result_class);
  main.variable(observer("mutable backup_result_class")).define("mutable backup_result_class", ["Mutable", "initial backup_result_class"], (M, _) => new M(_));
  main.variable(observer("backup_result_class")).define("backup_result_class", ["mutable backup_result_class"], _ => _.generator);
  main.define("initial backup_class_button", _backup_class_button);
  main.variable(observer("mutable backup_class_button")).define("mutable backup_class_button", ["Mutable", "initial backup_class_button"], (M, _) => new M(_));
  main.variable(observer("backup_class_button")).define("backup_class_button", ["mutable backup_class_button"], _ => _.generator);
  main.define("initial backup_result_class_button", _backup_result_class_button);
  main.variable(observer("mutable backup_result_class_button")).define("mutable backup_result_class_button", ["Mutable", "initial backup_result_class_button"], (M, _) => new M(_));
  main.variable(observer("backup_result_class_button")).define("backup_result_class_button", ["mutable backup_result_class_button"], _ => _.generator);
  main.define("initial wind_pv_unrealistic_class_button", _wind_pv_unrealistic_class_button);
  main.variable(observer("mutable wind_pv_unrealistic_class_button")).define("mutable wind_pv_unrealistic_class_button", ["Mutable", "initial wind_pv_unrealistic_class_button"], (M, _) => new M(_));
  main.variable(observer("wind_pv_unrealistic_class_button")).define("wind_pv_unrealistic_class_button", ["mutable wind_pv_unrealistic_class_button"], _ => _.generator);
  main.define("initial wind_pv_unrealistic_result_class_button", _wind_pv_unrealistic_result_class_button);
  main.variable(observer("mutable wind_pv_unrealistic_result_class_button")).define("mutable wind_pv_unrealistic_result_class_button", ["Mutable", "initial wind_pv_unrealistic_result_class_button"], (M, _) => new M(_));
  main.variable(observer("wind_pv_unrealistic_result_class_button")).define("wind_pv_unrealistic_result_class_button", ["mutable wind_pv_unrealistic_result_class_button"], _ => _.generator);
  main.define("initial mix_class", _mix_class);
  main.variable(observer("mutable mix_class")).define("mutable mix_class", ["Mutable", "initial mix_class"], (M, _) => new M(_));
  main.variable(observer("mix_class")).define("mix_class", ["mutable mix_class"], _ => _.generator);
  main.define("initial wind_pv_unrealistic_class", _wind_pv_unrealistic_class);
  main.variable(observer("mutable wind_pv_unrealistic_class")).define("mutable wind_pv_unrealistic_class", ["Mutable", "initial wind_pv_unrealistic_class"], (M, _) => new M(_));
  main.variable(observer("wind_pv_unrealistic_class")).define("wind_pv_unrealistic_class", ["mutable wind_pv_unrealistic_class"], _ => _.generator);
  main.define("initial wind_pv_unrealistic_result_class", _wind_pv_unrealistic_result_class);
  main.variable(observer("mutable wind_pv_unrealistic_result_class")).define("mutable wind_pv_unrealistic_result_class", ["Mutable", "initial wind_pv_unrealistic_result_class"], (M, _) => new M(_));
  main.variable(observer("wind_pv_unrealistic_result_class")).define("wind_pv_unrealistic_result_class", ["mutable wind_pv_unrealistic_result_class"], _ => _.generator);
  main.define("initial wind_pv_unrealistic_result_after_class_button", _wind_pv_unrealistic_result_after_class_button);
  main.variable(observer("mutable wind_pv_unrealistic_result_after_class_button")).define("mutable wind_pv_unrealistic_result_after_class_button", ["Mutable", "initial wind_pv_unrealistic_result_after_class_button"], (M, _) => new M(_));
  main.variable(observer("wind_pv_unrealistic_result_after_class_button")).define("wind_pv_unrealistic_result_after_class_button", ["mutable wind_pv_unrealistic_result_after_class_button"], _ => _.generator);
  main.define("initial nuclear_button_text", _nuclear_button_text);
  main.variable(observer("mutable nuclear_button_text")).define("mutable nuclear_button_text", ["Mutable", "initial nuclear_button_text"], (M, _) => new M(_));
  main.variable(observer("nuclear_button_text")).define("nuclear_button_text", ["mutable nuclear_button_text"], _ => _.generator);
  main.define("initial coal_button_text", _coal_button_text);
  main.variable(observer("mutable coal_button_text")).define("mutable coal_button_text", ["Mutable", "initial coal_button_text"], (M, _) => new M(_));
  main.variable(observer("coal_button_text")).define("coal_button_text", ["mutable coal_button_text"], _ => _.generator);
  main.define("initial wind_pv_button_text", _wind_pv_button_text);
  main.variable(observer("mutable wind_pv_button_text")).define("mutable wind_pv_button_text", ["Mutable", "initial wind_pv_button_text"], (M, _) => new M(_));
  main.variable(observer("wind_pv_button_text")).define("wind_pv_button_text", ["mutable wind_pv_button_text"], _ => _.generator);
  main.variable(observer()).define(["htl"], _42);
  main.variable(observer()).define(["htl"], _43);
  main.variable(observer("netto_parameter")).define("netto_parameter", ["viewof netto_parameter_scenario_view","Inputs","netto_parameter_scenario","Event","mutable netto_parameter_function"], _netto_parameter);
  main.variable(observer("netto_parameter_copy")).define("netto_parameter_copy", ["viewof netto_parameter_scenario_view","Inputs","netto_parameter_scenario","Event","mutable netto_parameter_function"], _netto_parameter_copy);
  main.variable(observer()).define(["htl"], _46);
  main.variable(observer("flexibility_parameter")).define("flexibility_parameter", ["viewof flexibility_parameter_scenario_view","Inputs","flexibility_parameter_scenario","Event","mutable flexibility_parameter_function"], _flexibility_parameter);
  main.variable(observer("flexibility_parameter_copy")).define("flexibility_parameter_copy", ["viewof flexibility_parameter_scenario_view","Inputs","flexibility_parameter_scenario","Event","mutable flexibility_parameter_function"], _flexibility_parameter_copy);
  main.variable(observer()).define(["htl"], _49);
  main.variable(observer("wind_onshore_parameter")).define("wind_onshore_parameter", ["viewof wind_onshore_parameter_scenario_view","Inputs","wind_onshore_parameter_scenario","Event","mutable wind_onshore_parameter_function"], _wind_onshore_parameter);
  main.variable(observer("wind_onshore_parameter_copy")).define("wind_onshore_parameter_copy", ["viewof wind_onshore_parameter_scenario_view","Inputs","wind_onshore_parameter_scenario","Event","mutable wind_onshore_parameter_function"], _wind_onshore_parameter_copy);
  main.variable(observer()).define(["htl"], _52);
  main.variable(observer("wind_offshore_parameter")).define("wind_offshore_parameter", ["viewof wind_offshore_parameter_scenario_view","Inputs","wind_offshore_parameter_scenario","Event","mutable wind_offshore_parameter_function"], _wind_offshore_parameter);
  main.variable(observer("wind_offshore_parameter_copy")).define("wind_offshore_parameter_copy", ["viewof wind_offshore_parameter_scenario_view","Inputs","wind_offshore_parameter_scenario","Event","mutable wind_offshore_parameter_function"], _wind_offshore_parameter_copy);
  main.variable(observer()).define(["htl"], _55);
  main.variable(observer("photovoltaik_parameter")).define("photovoltaik_parameter", ["viewof photovoltaik_parameter_scenario_view","Inputs","photovoltaik_parameter_scenario","Event","mutable photovoltaik_parameter_function"], _photovoltaik_parameter);
  main.variable(observer("photovoltaik_parameter_copy")).define("photovoltaik_parameter_copy", ["viewof photovoltaik_parameter_scenario_view","Inputs","photovoltaik_parameter_scenario","Event","mutable photovoltaik_parameter_function"], _photovoltaik_parameter_copy);
  main.variable(observer()).define(["htl"], _58);
  main.variable(observer("ratio_renewable_import_parameter_copy")).define("ratio_renewable_import_parameter_copy", ["viewof ratio_renewable_import_parameter_view","Inputs","Event","mutable ratio_renewable_import_parameter_function"], _ratio_renewable_import_parameter_copy);
  main.variable(observer()).define(["htl"], _60);
  main.variable(observer("electrolysis_parameter")).define("electrolysis_parameter", ["viewof electrolysis_parameter_scenario_view","Inputs","electrolysis_parameter_scenario","Event","mutable electrolysis_parameter_function"], _electrolysis_parameter);
  main.variable(observer("electrolysis_parameter_copy")).define("electrolysis_parameter_copy", ["viewof electrolysis_parameter_scenario_view","Inputs","electrolysis_parameter_scenario","Event","mutable electrolysis_parameter_function"], _electrolysis_parameter_copy);
  main.variable(observer()).define(["htl"], _63);
  main.variable(observer("imports_paramter")).define("imports_paramter", ["viewof imports_paramter_scenario_view","Inputs","imports_paramter_scenario","Event","mutable imports_paramter_function"], _imports_paramter);
  main.variable(observer("imports_paramter_copy")).define("imports_paramter_copy", ["viewof imports_paramter_scenario_view","Inputs","imports_paramter_scenario","Event","mutable imports_paramter_function"], _imports_paramter_copy);
  main.variable(observer()).define(["htl"], _66);
  main.variable(observer("gas_power_parameter")).define("gas_power_parameter", ["viewof gas_power_parameter_scenario_view","Inputs","gas_power_parameter_scenario","Event","mutable gas_power_parameter_function"], _gas_power_parameter);
  main.variable(observer("gas_power_parameter_copy")).define("gas_power_parameter_copy", ["viewof gas_power_parameter_scenario_view","Inputs","gas_power_parameter_scenario","Event","mutable gas_power_parameter_function"], _gas_power_parameter_copy);
  main.variable(observer()).define(["htl"], _69);
  main.variable(observer("brown_coal_power_parameter")).define("brown_coal_power_parameter", ["viewof brown_coal_power_parameter_scenario_view","Inputs","brown_coal_power_parameter_scenario","Event","mutable brown_coal_power_parameter_function"], _brown_coal_power_parameter);
  main.variable(observer("brown_coal_power_parameter_copy")).define("brown_coal_power_parameter_copy", ["viewof brown_coal_power_parameter_scenario_view","Inputs","brown_coal_power_parameter_scenario","Event","mutable brown_coal_power_parameter_function"], _brown_coal_power_parameter_copy);
  main.variable(observer()).define(["htl"], _72);
  main.variable(observer("hard_coal_power_parameter")).define("hard_coal_power_parameter", ["viewof hard_coal_power_parameter_scenario_view","Inputs","hard_coal_power_parameter_scenario","Event","mutable hard_coal_power_parameter_function"], _hard_coal_power_parameter);
  main.variable(observer("hard_coal_power_parameter_copy")).define("hard_coal_power_parameter_copy", ["viewof hard_coal_power_parameter_scenario_view","Inputs","hard_coal_power_parameter_scenario","Event","mutable hard_coal_power_parameter_function"], _hard_coal_power_parameter_copy);
  main.variable(observer()).define(["htl"], _75);
  main.variable(observer("nuclear_power_parameter")).define("nuclear_power_parameter", ["viewof nuclear_power_parameter_view","Inputs","nuclear_power_parameter_scenario","Event","mutable nuclear_power_parameter_function"], _nuclear_power_parameter);
  main.variable(observer("nuclear_power_parameter_copy")).define("nuclear_power_parameter_copy", ["viewof nuclear_power_parameter_view","Inputs","nuclear_power_parameter_scenario","Event","mutable nuclear_power_parameter_function"], _nuclear_power_parameter_copy);
  main.variable(observer()).define(["htl"], _78);
  main.define("initial data_for_scenario", ["FileAttachment"], _data_for_scenario);
  main.variable(observer("mutable data_for_scenario")).define("mutable data_for_scenario", ["Mutable", "initial data_for_scenario"], (M, _) => new M(_));
  main.variable(observer("data_for_scenario")).define("data_for_scenario", ["mutable data_for_scenario"], _ => _.generator);
  main.variable(observer()).define(["htl"], _80);
  main.define("initial netto_parameter_scenario", _netto_parameter_scenario);
  main.variable(observer("mutable netto_parameter_scenario")).define("mutable netto_parameter_scenario", ["Mutable", "initial netto_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("netto_parameter_scenario")).define("netto_parameter_scenario", ["mutable netto_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof netto_parameter_scenario_view")).define("viewof netto_parameter_scenario_view", ["View","netto_parameter_scenario"], _netto_parameter_scenario_view);
  main.variable(observer("netto_parameter_scenario_view")).define("netto_parameter_scenario_view", ["Generators", "viewof netto_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial wind_onshore_parameter_scenario", _wind_onshore_parameter_scenario);
  main.variable(observer("mutable wind_onshore_parameter_scenario")).define("mutable wind_onshore_parameter_scenario", ["Mutable", "initial wind_onshore_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("wind_onshore_parameter_scenario")).define("wind_onshore_parameter_scenario", ["mutable wind_onshore_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof wind_onshore_parameter_scenario_view")).define("viewof wind_onshore_parameter_scenario_view", ["View","wind_onshore_parameter_scenario"], _wind_onshore_parameter_scenario_view);
  main.variable(observer("wind_onshore_parameter_scenario_view")).define("wind_onshore_parameter_scenario_view", ["Generators", "viewof wind_onshore_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial technology_wind_parameter_scenario", _technology_wind_parameter_scenario);
  main.variable(observer("mutable technology_wind_parameter_scenario")).define("mutable technology_wind_parameter_scenario", ["Mutable", "initial technology_wind_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("technology_wind_parameter_scenario")).define("technology_wind_parameter_scenario", ["mutable technology_wind_parameter_scenario"], _ => _.generator);
  main.define("initial wind_offshore_parameter_scenario", _wind_offshore_parameter_scenario);
  main.variable(observer("mutable wind_offshore_parameter_scenario")).define("mutable wind_offshore_parameter_scenario", ["Mutable", "initial wind_offshore_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("wind_offshore_parameter_scenario")).define("wind_offshore_parameter_scenario", ["mutable wind_offshore_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof wind_offshore_parameter_scenario_view")).define("viewof wind_offshore_parameter_scenario_view", ["View","wind_offshore_parameter_scenario"], _wind_offshore_parameter_scenario_view);
  main.variable(observer("wind_offshore_parameter_scenario_view")).define("wind_offshore_parameter_scenario_view", ["Generators", "viewof wind_offshore_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial photovoltaik_parameter_scenario", _photovoltaik_parameter_scenario);
  main.variable(observer("mutable photovoltaik_parameter_scenario")).define("mutable photovoltaik_parameter_scenario", ["Mutable", "initial photovoltaik_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("photovoltaik_parameter_scenario")).define("photovoltaik_parameter_scenario", ["mutable photovoltaik_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof photovoltaik_parameter_scenario_view")).define("viewof photovoltaik_parameter_scenario_view", ["View","photovoltaik_parameter_scenario"], _photovoltaik_parameter_scenario_view);
  main.variable(observer("photovoltaik_parameter_scenario_view")).define("photovoltaik_parameter_scenario_view", ["Generators", "viewof photovoltaik_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial storage_pump_capacity_parameter_scenario", _storage_pump_capacity_parameter_scenario);
  main.variable(observer("mutable storage_pump_capacity_parameter_scenario")).define("mutable storage_pump_capacity_parameter_scenario", ["Mutable", "initial storage_pump_capacity_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("storage_pump_capacity_parameter_scenario")).define("storage_pump_capacity_parameter_scenario", ["mutable storage_pump_capacity_parameter_scenario"], _ => _.generator);
  main.define("initial storage_pump_power_parameter_scenario", _storage_pump_power_parameter_scenario);
  main.variable(observer("mutable storage_pump_power_parameter_scenario")).define("mutable storage_pump_power_parameter_scenario", ["Mutable", "initial storage_pump_power_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("storage_pump_power_parameter_scenario")).define("storage_pump_power_parameter_scenario", ["mutable storage_pump_power_parameter_scenario"], _ => _.generator);
  main.define("initial storage_battery_capacity_parameter_scenario", _storage_battery_capacity_parameter_scenario);
  main.variable(observer("mutable storage_battery_capacity_parameter_scenario")).define("mutable storage_battery_capacity_parameter_scenario", ["Mutable", "initial storage_battery_capacity_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("storage_battery_capacity_parameter_scenario")).define("storage_battery_capacity_parameter_scenario", ["mutable storage_battery_capacity_parameter_scenario"], _ => _.generator);
  main.define("initial electrolysis_parameter_scenario", _electrolysis_parameter_scenario);
  main.variable(observer("mutable electrolysis_parameter_scenario")).define("mutable electrolysis_parameter_scenario", ["Mutable", "initial electrolysis_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("electrolysis_parameter_scenario")).define("electrolysis_parameter_scenario", ["mutable electrolysis_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof electrolysis_parameter_scenario_view")).define("viewof electrolysis_parameter_scenario_view", ["View","electrolysis_parameter_scenario"], _electrolysis_parameter_scenario_view);
  main.variable(observer("electrolysis_parameter_scenario_view")).define("electrolysis_parameter_scenario_view", ["Generators", "viewof electrolysis_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial imports_paramter_scenario", _imports_paramter_scenario);
  main.variable(observer("mutable imports_paramter_scenario")).define("mutable imports_paramter_scenario", ["Mutable", "initial imports_paramter_scenario"], (M, _) => new M(_));
  main.variable(observer("imports_paramter_scenario")).define("imports_paramter_scenario", ["mutable imports_paramter_scenario"], _ => _.generator);
  main.variable(observer("viewof imports_paramter_scenario_view")).define("viewof imports_paramter_scenario_view", ["View","imports_paramter_scenario"], _imports_paramter_scenario_view);
  main.variable(observer("imports_paramter_scenario_view")).define("imports_paramter_scenario_view", ["Generators", "viewof imports_paramter_scenario_view"], (G, _) => G.input(_));
  main.define("initial gas_power_parameter_scenario", _gas_power_parameter_scenario);
  main.variable(observer("mutable gas_power_parameter_scenario")).define("mutable gas_power_parameter_scenario", ["Mutable", "initial gas_power_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("gas_power_parameter_scenario")).define("gas_power_parameter_scenario", ["mutable gas_power_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof gas_power_parameter_scenario_view")).define("viewof gas_power_parameter_scenario_view", ["View","gas_power_parameter_scenario"], _gas_power_parameter_scenario_view);
  main.variable(observer("gas_power_parameter_scenario_view")).define("gas_power_parameter_scenario_view", ["Generators", "viewof gas_power_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial brown_coal_power_parameter_scenario", _brown_coal_power_parameter_scenario);
  main.variable(observer("mutable brown_coal_power_parameter_scenario")).define("mutable brown_coal_power_parameter_scenario", ["Mutable", "initial brown_coal_power_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("brown_coal_power_parameter_scenario")).define("brown_coal_power_parameter_scenario", ["mutable brown_coal_power_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof brown_coal_power_parameter_scenario_view")).define("viewof brown_coal_power_parameter_scenario_view", ["View","brown_coal_power_parameter_scenario"], _brown_coal_power_parameter_scenario_view);
  main.variable(observer("brown_coal_power_parameter_scenario_view")).define("brown_coal_power_parameter_scenario_view", ["Generators", "viewof brown_coal_power_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial hard_coal_power_parameter_scenario", _hard_coal_power_parameter_scenario);
  main.variable(observer("mutable hard_coal_power_parameter_scenario")).define("mutable hard_coal_power_parameter_scenario", ["Mutable", "initial hard_coal_power_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("hard_coal_power_parameter_scenario")).define("hard_coal_power_parameter_scenario", ["mutable hard_coal_power_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof hard_coal_power_parameter_scenario_view")).define("viewof hard_coal_power_parameter_scenario_view", ["View","hard_coal_power_parameter_scenario"], _hard_coal_power_parameter_scenario_view);
  main.variable(observer("hard_coal_power_parameter_scenario_view")).define("hard_coal_power_parameter_scenario_view", ["Generators", "viewof hard_coal_power_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial nuclear_power_parameter_scenario", _nuclear_power_parameter_scenario);
  main.variable(observer("mutable nuclear_power_parameter_scenario")).define("mutable nuclear_power_parameter_scenario", ["Mutable", "initial nuclear_power_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("nuclear_power_parameter_scenario")).define("nuclear_power_parameter_scenario", ["mutable nuclear_power_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof nuclear_power_parameter_view")).define("viewof nuclear_power_parameter_view", ["View","nuclear_power_parameter_scenario"], _nuclear_power_parameter_view);
  main.variable(observer("nuclear_power_parameter_view")).define("nuclear_power_parameter_view", ["Generators", "viewof nuclear_power_parameter_view"], (G, _) => G.input(_));
  main.define("initial flexibility_parameter_scenario", _flexibility_parameter_scenario);
  main.variable(observer("mutable flexibility_parameter_scenario")).define("mutable flexibility_parameter_scenario", ["Mutable", "initial flexibility_parameter_scenario"], (M, _) => new M(_));
  main.variable(observer("flexibility_parameter_scenario")).define("flexibility_parameter_scenario", ["mutable flexibility_parameter_scenario"], _ => _.generator);
  main.variable(observer("viewof flexibility_parameter_scenario_view")).define("viewof flexibility_parameter_scenario_view", ["View","flexibility_parameter_scenario"], _flexibility_parameter_scenario_view);
  main.variable(observer("flexibility_parameter_scenario_view")).define("flexibility_parameter_scenario_view", ["Generators", "viewof flexibility_parameter_scenario_view"], (G, _) => G.input(_));
  main.define("initial scenario", _scenario);
  main.variable(observer("mutable scenario")).define("mutable scenario", ["Mutable", "initial scenario"], (M, _) => new M(_));
  main.variable(observer("scenario")).define("scenario", ["mutable scenario"], _ => _.generator);
  main.define("initial technology_factor", ["select_technology_value"], _technology_factor);
  main.variable(observer("mutable technology_factor")).define("mutable technology_factor", ["Mutable", "initial technology_factor"], (M, _) => new M(_));
  main.variable(observer("technology_factor")).define("technology_factor", ["mutable technology_factor"], _ => _.generator);
  main.define("initial storage_management_scenario", _storage_management_scenario);
  main.variable(observer("mutable storage_management_scenario")).define("mutable storage_management_scenario", ["Mutable", "initial storage_management_scenario"], (M, _) => new M(_));
  main.variable(observer("storage_management_scenario")).define("storage_management_scenario", ["mutable storage_management_scenario"], _ => _.generator);
  main.define("initial flexibility_given", _flexibility_given);
  main.variable(observer("mutable flexibility_given")).define("mutable flexibility_given", ["Mutable", "initial flexibility_given"], (M, _) => new M(_));
  main.variable(observer("flexibility_given")).define("flexibility_given", ["mutable flexibility_given"], _ => _.generator);
  main.variable(observer("viewof ratio_renewable_import_parameter_view")).define("viewof ratio_renewable_import_parameter_view", ["View"], _ratio_renewable_import_parameter_view);
  main.variable(observer("ratio_renewable_import_parameter_view")).define("ratio_renewable_import_parameter_view", ["Generators", "viewof ratio_renewable_import_parameter_view"], (G, _) => G.input(_));
  main.variable(observer()).define(["htl"], _112);
  main.define("initial netto_parameter_function", _netto_parameter_function);
  main.variable(observer("mutable netto_parameter_function")).define("mutable netto_parameter_function", ["Mutable", "initial netto_parameter_function"], (M, _) => new M(_));
  main.variable(observer("netto_parameter_function")).define("netto_parameter_function", ["mutable netto_parameter_function"], _ => _.generator);
  main.define("initial wind_onshore_parameter_function", _wind_onshore_parameter_function);
  main.variable(observer("mutable wind_onshore_parameter_function")).define("mutable wind_onshore_parameter_function", ["Mutable", "initial wind_onshore_parameter_function"], (M, _) => new M(_));
  main.variable(observer("wind_onshore_parameter_function")).define("wind_onshore_parameter_function", ["mutable wind_onshore_parameter_function"], _ => _.generator);
  main.define("initial wind_offshore_parameter_function", _wind_offshore_parameter_function);
  main.variable(observer("mutable wind_offshore_parameter_function")).define("mutable wind_offshore_parameter_function", ["Mutable", "initial wind_offshore_parameter_function"], (M, _) => new M(_));
  main.variable(observer("wind_offshore_parameter_function")).define("wind_offshore_parameter_function", ["mutable wind_offshore_parameter_function"], _ => _.generator);
  main.define("initial photovoltaik_parameter_function", _photovoltaik_parameter_function);
  main.variable(observer("mutable photovoltaik_parameter_function")).define("mutable photovoltaik_parameter_function", ["Mutable", "initial photovoltaik_parameter_function"], (M, _) => new M(_));
  main.variable(observer("photovoltaik_parameter_function")).define("photovoltaik_parameter_function", ["mutable photovoltaik_parameter_function"], _ => _.generator);
  main.define("initial storage_pump_capacity_parameter_function", _storage_pump_capacity_parameter_function);
  main.variable(observer("mutable storage_pump_capacity_parameter_function")).define("mutable storage_pump_capacity_parameter_function", ["Mutable", "initial storage_pump_capacity_parameter_function"], (M, _) => new M(_));
  main.variable(observer("storage_pump_capacity_parameter_function")).define("storage_pump_capacity_parameter_function", ["mutable storage_pump_capacity_parameter_function"], _ => _.generator);
  main.define("initial storage_pump_power_parameter_function", _storage_pump_power_parameter_function);
  main.variable(observer("mutable storage_pump_power_parameter_function")).define("mutable storage_pump_power_parameter_function", ["Mutable", "initial storage_pump_power_parameter_function"], (M, _) => new M(_));
  main.variable(observer("storage_pump_power_parameter_function")).define("storage_pump_power_parameter_function", ["mutable storage_pump_power_parameter_function"], _ => _.generator);
  main.define("initial storage_battery_capacity_parameter_function", _storage_battery_capacity_parameter_function);
  main.variable(observer("mutable storage_battery_capacity_parameter_function")).define("mutable storage_battery_capacity_parameter_function", ["Mutable", "initial storage_battery_capacity_parameter_function"], (M, _) => new M(_));
  main.variable(observer("storage_battery_capacity_parameter_function")).define("storage_battery_capacity_parameter_function", ["mutable storage_battery_capacity_parameter_function"], _ => _.generator);
  main.define("initial storage_battery_power_parameter_function", _storage_battery_power_parameter_function);
  main.variable(observer("mutable storage_battery_power_parameter_function")).define("mutable storage_battery_power_parameter_function", ["Mutable", "initial storage_battery_power_parameter_function"], (M, _) => new M(_));
  main.variable(observer("storage_battery_power_parameter_function")).define("storage_battery_power_parameter_function", ["mutable storage_battery_power_parameter_function"], _ => _.generator);
  main.define("initial electrolysis_parameter_function", _electrolysis_parameter_function);
  main.variable(observer("mutable electrolysis_parameter_function")).define("mutable electrolysis_parameter_function", ["Mutable", "initial electrolysis_parameter_function"], (M, _) => new M(_));
  main.variable(observer("electrolysis_parameter_function")).define("electrolysis_parameter_function", ["mutable electrolysis_parameter_function"], _ => _.generator);
  main.define("initial imports_paramter_function", _imports_paramter_function);
  main.variable(observer("mutable imports_paramter_function")).define("mutable imports_paramter_function", ["Mutable", "initial imports_paramter_function"], (M, _) => new M(_));
  main.variable(observer("imports_paramter_function")).define("imports_paramter_function", ["mutable imports_paramter_function"], _ => _.generator);
  main.define("initial gas_power_parameter_function", _gas_power_parameter_function);
  main.variable(observer("mutable gas_power_parameter_function")).define("mutable gas_power_parameter_function", ["Mutable", "initial gas_power_parameter_function"], (M, _) => new M(_));
  main.variable(observer("gas_power_parameter_function")).define("gas_power_parameter_function", ["mutable gas_power_parameter_function"], _ => _.generator);
  main.define("initial brown_coal_power_parameter_function", _brown_coal_power_parameter_function);
  main.variable(observer("mutable brown_coal_power_parameter_function")).define("mutable brown_coal_power_parameter_function", ["Mutable", "initial brown_coal_power_parameter_function"], (M, _) => new M(_));
  main.variable(observer("brown_coal_power_parameter_function")).define("brown_coal_power_parameter_function", ["mutable brown_coal_power_parameter_function"], _ => _.generator);
  main.define("initial hard_coal_power_parameter_function", _hard_coal_power_parameter_function);
  main.variable(observer("mutable hard_coal_power_parameter_function")).define("mutable hard_coal_power_parameter_function", ["Mutable", "initial hard_coal_power_parameter_function"], (M, _) => new M(_));
  main.variable(observer("hard_coal_power_parameter_function")).define("hard_coal_power_parameter_function", ["mutable hard_coal_power_parameter_function"], _ => _.generator);
  main.define("initial nuclear_power_parameter_function", _nuclear_power_parameter_function);
  main.variable(observer("mutable nuclear_power_parameter_function")).define("mutable nuclear_power_parameter_function", ["Mutable", "initial nuclear_power_parameter_function"], (M, _) => new M(_));
  main.variable(observer("nuclear_power_parameter_function")).define("nuclear_power_parameter_function", ["mutable nuclear_power_parameter_function"], _ => _.generator);
  main.define("initial other_power_plants_parameter_function", _other_power_plants_parameter_function);
  main.variable(observer("mutable other_power_plants_parameter_function")).define("mutable other_power_plants_parameter_function", ["Mutable", "initial other_power_plants_parameter_function"], (M, _) => new M(_));
  main.variable(observer("other_power_plants_parameter_function")).define("other_power_plants_parameter_function", ["mutable other_power_plants_parameter_function"], _ => _.generator);
  main.define("initial flexibility_parameter_function", _flexibility_parameter_function);
  main.variable(observer("mutable flexibility_parameter_function")).define("mutable flexibility_parameter_function", ["Mutable", "initial flexibility_parameter_function"], (M, _) => new M(_));
  main.variable(observer("flexibility_parameter_function")).define("flexibility_parameter_function", ["mutable flexibility_parameter_function"], _ => _.generator);
  main.define("initial years_scenario_parameter_function", _years_scenario_parameter_function);
  main.variable(observer("mutable years_scenario_parameter_function")).define("mutable years_scenario_parameter_function", ["Mutable", "initial years_scenario_parameter_function"], (M, _) => new M(_));
  main.variable(observer("years_scenario_parameter_function")).define("years_scenario_parameter_function", ["mutable years_scenario_parameter_function"], _ => _.generator);
  main.variable(observer("technology_factor_function")).define("technology_factor_function", ["select_technology_value"], _technology_factor_function);
  main.define("initial storage_management_function", _storage_management_function);
  main.variable(observer("mutable storage_management_function")).define("mutable storage_management_function", ["Mutable", "initial storage_management_function"], (M, _) => new M(_));
  main.variable(observer("storage_management_function")).define("storage_management_function", ["mutable storage_management_function"], _ => _.generator);
  main.define("initial ratio_renewable_import_parameter_function", _ratio_renewable_import_parameter_function);
  main.variable(observer("mutable ratio_renewable_import_parameter_function")).define("mutable ratio_renewable_import_parameter_function", ["Mutable", "initial ratio_renewable_import_parameter_function"], (M, _) => new M(_));
  main.variable(observer("ratio_renewable_import_parameter_function")).define("ratio_renewable_import_parameter_function", ["mutable ratio_renewable_import_parameter_function"], _ => _.generator);
  main.variable(observer()).define(["htl"], _133);
  main.variable(observer()).define(["htl"], _134);
  main.variable(observer("data_scenario")).define("data_scenario", ["generate_scenario_data","data_for_scenario","photovoltaik_parameter_function","wind_offshore_parameter_function","wind_onshore_parameter_function","technology_factor_function","nuclear_power_parameter_function","brown_coal_power_parameter_function","hard_coal_power_parameter_function","gas_power_parameter_function","imports_paramter_function","other_power_plants_parameter_function","electrolysis_parameter_function","storage_pump_capacity_parameter_function","storage_pump_power_parameter_function","storage_battery_capacity_parameter_function","storage_battery_power_parameter_function","storage_management_function","netto_parameter_function","flexibility_parameter_function","years_scenario_parameter_function"], _data_scenario);
  main.variable(observer("results_analaysis_scenario")).define("results_analaysis_scenario", ["generate_analysis_scenario","data_scenario"], _results_analaysis_scenario);
  main.variable(observer()).define(["htl"], _137);
  main.variable(observer()).define(["htl"], _138);
  main.variable(observer("efficiency_electricity_gas")).define("efficiency_electricity_gas", _efficiency_electricity_gas);
  main.variable(observer("efficiency_gas_electricity")).define("efficiency_gas_electricity", _efficiency_gas_electricity);
  main.variable(observer("dates_of_a_year_365")).define("dates_of_a_year_365", ["getDates"], _dates_of_a_year_365);
  main.variable(observer("dates_of_a_year_366")).define("dates_of_a_year_366", ["getDates"], _dates_of_a_year_366);
  main.variable(observer("dates_2015")).define("dates_2015", ["getDates"], _dates_2015);
  main.variable(observer("dates_2016")).define("dates_2016", ["getDates"], _dates_2016);
  main.variable(observer("dates_2017")).define("dates_2017", ["getDates"], _dates_2017);
  main.variable(observer("dates_2018")).define("dates_2018", ["getDates"], _dates_2018);
  main.variable(observer("dates_2019")).define("dates_2019", ["getDates"], _dates_2019);
  main.variable(observer("dates_2020")).define("dates_2020", ["getDates"], _dates_2020);
  main.variable(observer("dates_2021")).define("dates_2021", ["getDates"], _dates_2021);
  main.variable(observer()).define(["htl"], _150);
  main.variable(observer()).define(["htl"], _151);
  main.variable(observer("compute_dsm")).define("compute_dsm", ["_"], _compute_dsm);
  main.variable(observer("generate_scenario_data")).define("generate_scenario_data", ["compute_increase_ratio","compute_dsm"], _generate_scenario_data);
  main.variable(observer("data_filter")).define("data_filter", _data_filter);
  main.variable(observer("compute_dunkelflauten")).define("compute_dunkelflauten", ["_","moment","substract","rounding","get_year_index"], _compute_dunkelflauten);
  main.variable(observer("generate_analysis_scenario")).define("generate_analysis_scenario", ["_","data_filter","compute_dunkelflauten","ratio_renewable_import_parameter_function","mutable highlight_class"], _generate_analysis_scenario);
  main.variable(observer("plot_heat_map")).define("plot_heat_map", ["dates_of_a_year_366","get_date_by_year_dayOfYear","draw_echart"], _plot_heat_map);
  main.variable(observer()).define(["htl"], _158);
  main.variable(observer("compute_class_coverage")).define("compute_class_coverage", ["rounding"], _compute_class_coverage);
  main.variable(observer("compute_class_renewable")).define("compute_class_renewable", ["rounding"], _compute_class_renewable);
  main.variable(observer("substract")).define("substract", _substract);
  main.variable(observer("addition")).define("addition", _addition);
  main.variable(observer("second_max")).define("second_max", _second_max);
  main.variable(observer("select_technology_value")).define("select_technology_value", ["scenario"], _select_technology_value);
  main.variable(observer("compute_increase_ratio")).define("compute_increase_ratio", ["_"], _compute_increase_ratio);
  main.variable(observer("rounding")).define("rounding", _rounding);
  main.variable(observer("draw_echart")).define("draw_echart", ["html","echarts"], _draw_echart);
  main.variable(observer("set")).define("set", ["Event"], _set);
  main.variable(observer("get_year_index")).define("get_year_index", _get_year_index);
  main.variable(observer("getDates")).define("getDates", ["moment"], _getDates);
  main.variable(observer("get_date_by_year_dayOfYear")).define("get_date_by_year_dayOfYear", ["dates_of_a_year_366","dates_of_a_year_365"], _get_date_by_year_dayOfYear);
  main.variable(observer("get_date_by_year_day_full_date")).define("get_date_by_year_day_full_date", ["dates_2015","dates_2016","dates_2017","dates_2018","dates_2019","dates_2020","dates_2021"], _get_date_by_year_day_full_date);
  main.variable(observer()).define(["htl"], _173);
  main.variable(observer()).define(["htl"], _174);
  main.variable(observer("_")).define("_", ["require"], __);
  main.variable(observer("echarts")).define("echarts", ["require"], _echarts);
  main.variable(observer("moment")).define("moment", ["require"], _moment);
  main.variable(observer("html")).define("html", ["htl"], _html);
  main.variable(observer()).define(["require","FileAttachment"], _179);
  const child1 = runtime.module(define1);
  main.import("disposal", child1);
  main.variable(observer("bind")).define("bind", ["disposal","set","eventof","get"], _bind);
  main.variable(observer("eventof")).define("eventof", _eventof);
  main.variable(observer("get")).define("get", _get);
  main.variable(observer("View")).define("View", ["bind"], _View);
  return main;
}
